(ns bleene.mock-transforms)

(def transforms
{
    "transforms" {
        "data" [
            {
                "master-id" "8a732a1e-94e7-4048-8b48-179ed22d3b87",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8a732a1e-94e7-4048-8b48-179ed22d3b87",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-23T13:06:14Z",
                "name" "V_Dev_Traveller_AccountInvoice_Raw",
                "status" "active",
                "created-at" "2021-12-23T13:06:14Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "abb9fad3-ff7c-4354-8b30-668a3fc946ff",
                "ignore-parser" false,
                
                "output-tables" [],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "abb9fad3-ff7c-4354-8b30-668a3fc946ff",
                "updated-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "hour" nil,
                "updated-at" "2021-06-25T09:15:06Z",
                "name" "Clear data",
                "status" "active",
                "created-at" "2021-06-25T09:15:06Z",
                "created-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "39471ce0-d96b-4359-8486-07f091ae649c"
            },
            {
                "master-id" "75981838-e757-4b9b-8f46-9775a1c8c2b2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "75981838-e757-4b9b-8f46-9775a1c8c2b2",
                "updated-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "hour" nil,
                "updated-at" "2021-06-25T09:26:46Z",
                "name" "Create View",
                "status" "active",
                "created-at" "2021-06-25T09:26:46Z",
                "created-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "39471ce0-d96b-4359-8486-07f091ae649c"
            },
            {
                "master-id" "50894491-f1e8-4b85-ab94-4da6228c6739",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "50894491-f1e8-4b85-ab94-4da6228c6739",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-23T14:34:01Z",
                "name" "V_Dev_Traveller_Booking_Raw",
                "status" "active",
                "created-at" "2021-12-23T14:34:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "a10fec3e-bd27-4b00-b575-2bce6cf71644",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "92efe085-51f1-4624-8895-70e9cc639fa1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-11-08T09:17:25Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountFeatures_History",
                "status" "active",
                "created-at" "2021-07-08T15:21:48Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "43a0810b-047a-4bf8-9cf3-49b9e2a5701d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "18ea5598-934e-41e4-8a62-b441983c85ae",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-11-08T09:17:45Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountProperties_History",
                "status" "active",
                "created-at" "2021-07-08T15:32:36Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c136ba88-eec4-46ae-8cfb-d9df865af0ad",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c136ba88-eec4-46ae-8cfb-d9df865af0ad",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "hour" nil,
                "updated-at" "2021-05-07T09:22:34Z",
                "name" "PROD.STAGING.ATTRIBUTECSV",
                "status" "active",
                "created-at" "2021-05-07T09:22:34Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "58c7aef3-f472-411d-a179-8d306def0b2d"
            },
            {
                "master-id" "a96db840-e83c-4637-90e8-bab74ee81b1c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a96db840-e83c-4637-90e8-bab74ee81b1c",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "hour" nil,
                "updated-at" "2021-05-07T09:25:13Z",
                "name" "PROD.STAGING.FEATURECSV",
                "status" "active",
                "created-at" "2021-05-07T09:25:13Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "58c7aef3-f472-411d-a179-8d306def0b2d"
            },
            {
                "master-id" "37fc26fb-dc0f-4360-ac83-68d496c871b1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "715cc47e-648d-41f9-9ff7-558dffbe3621",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "hour" nil,
                "updated-at" "2021-05-07T09:32:59Z",
                "name" "Transform 2021-05-07 09:26:53",
                "status" "active",
                "created-at" "2021-05-07T09:26:53Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "58c7aef3-f472-411d-a179-8d306def0b2d"
            },
            {
                "master-id" "b91e1c91-b0f4-4959-a11a-114bbe1b1990",
                "ignore-parser" false,
                
                "output-tables" [],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8b853d1a-c916-421f-8198-5bd5437f1d26",
                "updated-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
                "hour" nil,
                "updated-at" "2021-05-28T08:52:35Z",
                "name" "insert_better_name_here",
                "status" "active",
                "created-at" "2021-05-28T08:50:17Z",
                "created-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "98665e48-3297-4f9e-bb89-974c2d442c1e"
            },
            {
                "master-id" "a4148066-3ca0-4c85-a5de-abbdcff969e0",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "ea19e216-300e-416a-bbb3-45550c0aeb1c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-22T08:30:13Z",
                "name" "Dev_Dim_Property_Marketing_Feature_Load_Data",
                "status" "active",
                "created-at" "2021-06-25T13:19:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "295626d0-5065-4ae5-a74b-1e2275dba995",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "295626d0-5065-4ae5-a74b-1e2275dba995",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-06-18T15:26:50Z",
                "name" "V_Dev_Traveller_Region_History",
                "status" "active",
                "created-at" "2021-06-18T15:26:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "379d65c4-3c4f-4cf7-a723-9fcdce89f87e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "58f7fb29-192e-470b-b81a-6b05195790fa",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-06-21T07:28:46Z",
                "name" "V_Dev_Service_Unit",
                "status" "active",
                "created-at" "2021-06-17T16:03:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "5b493c9f-a875-4443-9e0c-a09b5fdd678d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8ed6c5bb-b3b4-416e-811a-2e292f329e94",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-06-21T09:43:35Z",
                "name" "V_Dev_Property_In_Website_Region",
                "status" "active",
                "created-at" "2021-06-21T09:41:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "d971bd7b-9a00-4dbe-ba4b-aa2507870dfb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" true,
                "statements" [
























                ],
                "tags" [],
                "dow" nil,
                "id" "2f08ed80-cdce-4f27-891c-b387c41df9e8",
                "updated-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "hour" nil,
                "updated-at" "2021-06-25T09:14:11Z",
                "name" "Insert Historical  Data",
                "status" "active",
                "created-at" "2021-05-26T12:36:27Z",
                "created-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "39471ce0-d96b-4359-8486-07f091ae649c"
            },
            {
                "master-id" "36af3ee3-1559-4b4a-9428-2a99d9de4ab2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bdf1c0c4-21ad-4cbb-8447-79b41fce32ab",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-22T10:16:36Z",
                "name" "V_Dev_Property_To_Website_Town_Distance",
                "status" "active",
                "created-at" "2021-06-21T09:46:34Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "5c4e36fa-96aa-48a9-a726-73b78c75615c",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "5c4e36fa-96aa-48a9-a726-73b78c75615c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-27T11:59:10Z",
                "name" "Live_Dim_Property_Marketing_Feature_Load_Data",
                "status" "active",
                "created-at" "2021-07-27T11:59:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "d9569d72-97b3-4385-aae4-b88977886ef0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "196df9a4-5465-4a34-824b-e0181f5c3bd3",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-15T09:07:10Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH",
                "status" "active",
                "created-at" "2021-12-06T10:57:35Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "e5171af3-9e2b-47fa-8ba1-45e5abf2d852",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e5171af3-9e2b-47fa-8ba1-45e5abf2d852",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_Rate_Raw",
                "status" "active",
                "created-at" "2021-07-12T09:55:21Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "389fd9a9-093a-44a9-ba70-f72ff650dbab",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a2f40968-b545-4031-be3d-8d0abc2f5acb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:50Z",
                "name" "V_Dev_Traveller_Feature_Latest",
                "status" "active",
                "created-at" "2021-06-17T13:25:46Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "9702275e-b325-4ecc-8d2f-a4ca9c916bc1",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "3320f01d-014b-4025-a286-a552d8d60081",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-11-02T09:43:05Z",
                "name" "Dev_Dim_Discount_Load_Data",
                "status" "active",
                "created-at" "2021-10-29T15:04:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "8af8a316-805e-4194-a4b1-45454d3b42b9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "36bfd3ed-1957-4687-af61-83f671f7c3da",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:01Z",
                "name" "V_Dev_Traveller_CottagePricingCode_Latest",
                "status" "active",
                "created-at" "2021-07-09T15:33:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "731bc408-ba1f-4de5-99ed-f0c5430c82f1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1464d1d8-9b9d-412f-8c00-03522d2d9404",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:28Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountProperties_Latest",
                "status" "active",
                "created-at" "2021-07-08T15:34:56Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "468c0e20-f506-4b7b-a535-051851cfe107",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "468c0e20-f506-4b7b-a535-051851cfe107",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_NewWhiteLabels_Config_Raw",
                "status" "active",
                "created-at" "2021-07-26T12:48:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "41c8ce0b-fe73-478d-a1e7-56c618963e60",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "41c8ce0b-fe73-478d-a1e7-56c618963e60",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-27T09:44:03Z",
                "name" "V_Live_Property_In_Website_Region",
                "status" "active",
                "created-at" "2021-07-27T09:44:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "ddbc424a-5ad0-42fa-9578-912b57b7e4da",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ddbc424a-5ad0-42fa-9578-912b57b7e4da",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-27T09:37:40Z",
                "name" "V_Live_Service_Unit",
                "status" "active",
                "created-at" "2021-07-27T09:37:40Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "75dc4586-cad8-44ed-8c09-6a05437d2886",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "75dc4586-cad8-44ed-8c09-6a05437d2886",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-07-27T10:02:25Z",
                "name" "V_Live_Property_To_Website_Town_Distance",
                "status" "active",
                "created-at" "2021-07-27T10:02:25Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "7456fb1b-189b-42e2-8e30-ed24eaf78ea7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7456fb1b-189b-42e2-8e30-ed24eaf78ea7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_Contract_Raw",
                "status" "active",
                "created-at" "2021-07-09T13:00:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "620f9a3e-b127-4b9f-ba86-a67ad3178219",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5cbd57ab-0204-4016-a7a9-6b0164f83ea6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-14T09:25:18Z",
                "name" "V_Dev_Dim_Property_Marketing_Feature_Source",
                "status" "active",
                "created-at" "2021-06-21T13:16:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7f2ff4b6-3b44-444e-8ea7-8283f17f5fe2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7f63be62-7574-4ebe-a6c1-009694ff3166",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:53Z",
                "name" "V_Dev_Traveller_Calendar_Latest",
                "status" "active",
                "created-at" "2021-07-08T10:31:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "ee4ac8dc-a9ec-40fc-9ea9-eba3f4fa5307",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2179608a-414c-4dbb-9a70-b7f1a6bd8e7b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:09Z",
                "name" "V_Live_NewWhiteLabels_Config_Latest",
                "status" "active",
                "created-at" "2021-07-26T13:05:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "ffcaffad-337a-4baf-a4ee-51cd2256467d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ffcaffad-337a-4baf-a4ee-51cd2256467d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:03:44Z",
                "name" "V_Live_Traveller_Contract_History",
                "status" "active",
                "created-at" "2021-09-22T09:03:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e6c3992f-0692-40b2-9548-cfcff7ef1858",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e30ef5a8-2bd9-499b-baa1-a91f4dd51ac2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:07:04Z",
                "name" "V_Dev_Traveller_Profile_History",
                "status" "active",
                "created-at" "2021-06-18T14:37:32Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "af2db46a-fb81-4fa5-8ad2-f285e8cd14cd",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e62ac9d1-d806-43a6-a2a6-a8d4c5b6e3c6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:07:25Z",
                "name" "V_Dev_Traveller_Service_History",
                "status" "active",
                "created-at" "2021-06-17T15:08:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "2992f337-48ef-41be-b7d8-c0468d93e708",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "cfe91feb-bb02-4581-ab8d-9e4843d39859",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:06:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUP_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:05:55Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "f77b2ac7-2cea-46c2-bec7-16bd63cb6d30",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4befb2d5-287c-4184-8a10-bdb4d63cc5f8",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-28T09:38:27Z",
                "name" "V_Live_Dim_Property_Operation_Feature_Source",
                "status" "active",
                "created-at" "2021-07-27T11:32:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "8369691b-3c9e-4c9f-941a-4c35cda01de6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8369691b-3c9e-4c9f-941a-4c35cda01de6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:07:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:07:04Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "75da2f7a-b7f8-423b-8c0c-223bbf28ea9c",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "627d9bfb-a6a0-4886-b017-85cb04b28000",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-28T09:50:15Z",
                "name" "Live_Dim_Property_Operation_Feature_Load_Data",
                "status" "active",
                "created-at" "2021-07-27T12:27:08Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "83cb0474-9ba2-4024-966c-c6a2632433b2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1ee35c96-230f-4a84-b121-6bd5beaba164",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:00:12Z",
                "name" "V_Dev_HolidayCottages_SBLeadTimes_History",
                "status" "active",
                "created-at" "2021-06-21T09:29:25Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b17d22a4-55c1-458e-9654-8f099168c50b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "64345234-3c79-4453-b39f-5ff7b764f5cd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:55:29Z",
                "name" "V_Dev_HolidayCottages_Towns_History",
                "status" "active",
                "created-at" "2021-06-21T08:44:32Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "cc7534ec-c746-4591-b2ea-597b72a7147d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c990afc0-e148-49d2-a586-cd5607098bba",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:54:43Z",
                "name" "V_Dev_HolidayCottages_Regions_History",
                "status" "active",
                "created-at" "2021-06-21T08:59:36Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6c3e2b98-50a2-466b-98eb-e0638ac41423",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "63997cd7-39c1-4e99-b1ea-0483bb63a5d4",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:02:45Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscount_History",
                "status" "active",
                "created-at" "2021-07-08T14:23:20Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6c5238e2-40a2-483d-8f86-637aaca042bf",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5deb2ec4-7417-4a09-81b4-091775aa0354",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:55:01Z",
                "name" "V_Dev_HolidayCottages_SBWindows_History",
                "status" "active",
                "created-at" "2021-06-21T09:32:05Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "22592b45-e609-4699-80a6-43d4580c2593",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "16bb5671-bdf8-4d2e-90e2-e727053fbe5e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:55:12Z",
                "name" "V_Dev_HolidayCottages_SeasonalDates_History",
                "status" "active",
                "created-at" "2021-06-21T09:35:45Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "014e5fbb-93cc-47f4-b26a-b0928db50387",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "32d26da4-9422-4ba8-984f-fd2cdb3b66a9",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:55:41Z",
                "name" "V_Dev_NewWhiteLabels_Config_History",
                "status" "active",
                "created-at" "2021-06-21T07:57:32Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "5c04976b-a472-43ff-9efb-b736b97b9f87",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d1f52cd8-feeb-4d87-a8bb-0deca82317ed",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:55:56Z",
                "name" "V_Dev_NewWhiteLabels_Sites_History",
                "status" "active",
                "created-at" "2021-06-21T08:22:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "0d4e9a76-51c5-42cb-94ea-4ae60e2871a1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "03a69727-5d8a-4ffe-95ea-1bb8be6d60ac",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:56:11Z",
                "name" "V_Dev_Traveller_Attribute_History",
                "status" "active",
                "created-at" "2021-06-17T11:25:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "2d121011-d0c8-4f05-895b-6434c684e100",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d75c312f-0355-4ffd-9131-fc59fd8c607b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:56:32Z",
                "name" "V_Dev_Traveller_Calendar_History",
                "status" "active",
                "created-at" "2021-07-08T10:27:49Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "cd69385c-e656-49f3-b9dd-83358d784dc0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "42a2c27b-f2b9-4cdb-a532-a7bee3591691",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T13:56:46Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountAreaRegion_History",
                "status" "active",
                "created-at" "2021-07-08T15:01:30Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fb449972-e124-48af-b376-dc6bca9f2b9f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7af5f660-b16d-423d-8dd0-f54d7e335be5",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:03:37Z",
                "name" "V_Dev_Traveller_Contract_History",
                "status" "active",
                "created-at" "2021-07-09T13:08:41Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "73d35122-2a45-430f-9507-5771fb9034b8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c2dc45af-7642-4736-9fb3-3af43ca9003a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:06:44Z",
                "name" "V_Dev_Traveller_Object_History",
                "status" "active",
                "created-at" "2021-06-18T13:24:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "5974e196-d3bb-4b94-bbdc-e1a295088c50",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "cacf1e9e-e840-4ff8-bd73-ec364128599c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:04:05Z",
                "name" "V_Dev_Traveller_CottagePricingBand_History",
                "status" "active",
                "created-at" "2021-07-09T15:08:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b73b29d8-50cc-4aed-8747-3773f76a32c7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "351ed82b-245e-487c-9f7e-1d9ef192cd61",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:04:29Z",
                "name" "V_Dev_Traveller_CottagePricing_History",
                "status" "active",
                "created-at" "2021-07-09T13:32:32Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1a9af719-283a-48bb-8ed2-641a3cfa724e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "01fc0595-1f2e-4955-90a3-7e93af90d5ef",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:03:52Z",
                "name" "V_Dev_Traveller_CottagePricingAssignment_History",
                "status" "active",
                "created-at" "2021-07-09T14:05:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "476db077-4865-458e-b473-3d9917c03768",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2bc247aa-6f9d-4e94-a11e-20cf485d61d6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:04:19Z",
                "name" "V_Dev_Traveller_CottagePricingCode_History",
                "status" "active",
                "created-at" "2021-07-09T15:32:26Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "2a062765-eae4-4e77-ab49-b5a291fd0aa4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "11d6a18a-6c7e-48a0-a725-b7a5a2adbf87",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:04:41Z",
                "name" "V_Dev_Traveller_Feature_History",
                "status" "active",
                "created-at" "2021-06-17T13:18:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "0a9b9cbe-2442-41ba-9a94-0e39c4a1fc74",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9d8a4d01-585a-4830-a74e-999de4806b27",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:05:34Z",
                "name" "V_Dev_Traveller_Lookup_History",
                "status" "active",
                "created-at" "2021-06-18T13:11:07Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "52e8d842-7349-45f4-9991-688710dfbb47",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b7d1dd6b-f09d-4a30-8dac-ef179d32ebd0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:07:14Z",
                "name" "V_Dev_Traveller_Rate_History",
                "status" "active",
                "created-at" "2021-07-12T10:02:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "686bad69-d242-42a3-9ffe-b05ec7659627",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d16bdae1-5d4b-4bd9-bb3b-8d0a22e289a7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:06:54Z",
                "name" "V_Dev_Traveller_ProfileHeader_History",
                "status" "active",
                "created-at" "2021-06-18T14:52:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e514017f-c5cb-4424-9ac3-579a3c57437a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "adfb7fe1-cf52-4580-a3fb-fbc2473cb00f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:09:04Z",
                "name" "V_Dev_Traveller_Stock_History",
                "status" "active",
                "created-at" "2021-07-12T10:32:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "ab6499dd-9f3c-4525-bf20-f3a406e9c7bc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a667d542-2730-4d08-80cf-254a1aa0c0bf",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-19T14:09:31Z",
                "name" "V_Dev_Traveller_Unit_History",
                "status" "active",
                "created-at" "2021-06-17T15:48:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c16a1790-5b17-424d-9c9c-44578ba84298",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c16a1790-5b17-424d-9c9c-44578ba84298",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:13:28Z",
                "name" "V_Live_Traveller_Contract_Latest",
                "status" "active",
                "created-at" "2021-09-22T09:13:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0917bbfa-5fd6-4c92-adad-fdb3ca6a776e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0917bbfa-5fd6-4c92-adad-fdb3ca6a776e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:22:34Z",
                "name" "V_Live_Traveller_Calendar_History",
                "status" "active",
                "created-at" "2021-09-22T09:22:34Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6f71573b-58c3-462c-b69f-ac07f0483892",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6f71573b-58c3-462c-b69f-ac07f0483892",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:26:59Z",
                "name" "V_Live_Traveller_Calendar_Latest",
                "status" "active",
                "created-at" "2021-09-22T09:26:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "922ec89b-cd80-49ba-81c7-8f4d6a600fb0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4e394198-3028-44dc-ab4d-dd2f28416076",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:45:57Z",
                "name" "V_Live_HolidayCottages_Region_History",
                "status" "active",
                "created-at" "2021-07-26T12:24:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0f2053f9-11d6-41c7-af28-2d4970fc76ff",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dff24d39-e96f-4090-905b-514b28143c5c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:46:15Z",
                "name" "V_Live_HolidayCottages_Towns_History",
                "status" "active",
                "created-at" "2021-07-26T12:34:09Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "4a7aedf5-3924-4900-8aba-480ae19da6fc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "29c34dd1-ae49-4fa9-bfbd-6c879bcf646e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:46:27Z",
                "name" "V_Live_NewWhiteLabels_Config_History",
                "status" "active",
                "created-at" "2021-07-26T12:50:24Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "ebc046b6-9c12-4d73-a0bc-72b9b31d8c48",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "14817c66-fe91-4bed-8731-4e2ce7a487bc",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:46:41Z",
                "name" "V_Live_NewWhiteLabels_Sites_History",
                "status" "active",
                "created-at" "2021-07-26T13:59:07Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6d248a7c-81f0-4913-8a89-7432252291b5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "365a9467-11cf-4cad-89ad-148b98d13285",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:47:20Z",
                "name" "V_Live_Traveller_Login_History",
                "status" "active",
                "created-at" "2021-07-26T14:36:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "963ddad7-317b-4144-81dc-b98cac0f9aab",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1a66e7a4-67c6-4cbb-a0f5-150ddcf6379f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:46:57Z",
                "name" "V_Live_Traveller_Attribute_History",
                "status" "active",
                "created-at" "2021-07-26T14:07:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "5abae437-bad6-4ece-a7c9-f0fa4120a196",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "289a4e2d-9e39-442e-89d0-036766d48f6a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:47:07Z",
                "name" "V_Live_Traveller_Feature_History",
                "status" "active",
                "created-at" "2021-07-26T14:28:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "4a0ecc44-26aa-4ff1-8d01-03b44374d017",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "69ac161b-6e30-4059-b7c5-cddd3b1ba005",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:47:51Z",
                "name" "V_Live_Traveller_ProfileHeader_History",
                "status" "active",
                "created-at" "2021-07-26T15:00:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "9c55b28d-c98a-4030-942d-91075dba37e8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "70a0416e-4544-4fd9-9dda-8ff78a2ea432",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:47:32Z",
                "name" "V_Live_Traveller_Lookup_History",
                "status" "active",
                "created-at" "2021-07-26T14:40:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "886221cb-39b3-427c-88ce-0b34ae012d85",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "681b9f01-9c90-4db6-a613-edae39e47b0c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:48:33Z",
                "name" "V_Live_Traveller_Service_History",
                "status" "active",
                "created-at" "2021-07-26T15:06:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2eebb52b-14ac-4b88-88cd-a3a20f3b94cb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9d2ea64d-4c1f-434f-91d9-2fe825c2183c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:47:41Z",
                "name" "V_Live_Traveller_Object_History",
                "status" "active",
                "created-at" "2021-07-26T14:44:33Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "5a024bac-efe3-456d-b5cf-c75d913a44ce",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "23c2f15f-5692-45a8-a792-d6d58fcabd43",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:48:04Z",
                "name" "V_Live_Traveller_Profile_History",
                "status" "active",
                "created-at" "2021-07-26T14:55:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "c58ee274-ffac-43d3-88af-321a6bcb652e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "28226b04-0b8b-4c57-ac4e-25ab8d168409",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:48:18Z",
                "name" "V_Live_Traveller_Region_History",
                "status" "active",
                "created-at" "2021-07-26T15:02:56Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "3c2ba956-f207-4ac4-bc41-9b64ef89d463",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ba71cb37-a794-4572-b3ef-4dbe42056cd5",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T08:49:00Z",
                "name" "V_Live_Traveller_Unit_History",
                "status" "active",
                "created-at" "2021-07-26T15:13:08Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "3f001216-8092-4b7e-a47c-535b4fcbd633",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "3f001216-8092-4b7e-a47c-535b4fcbd633",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Attribute_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:04:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "f3c828c3-3eb7-4510-9636-6671a1820707",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "f3c828c3-3eb7-4510-9636-6671a1820707",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Feature_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:26:08Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a708ce9c-982a-41a9-9013-8413bd272580",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "a708ce9c-982a-41a9-9013-8413bd272580",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Service_Raw",
                "status" "active",
                "created-at" "2021-07-26T15:05:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "14c01d9e-1543-4798-a28b-d6d616cbeae1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "14c01d9e-1543-4798-a28b-d6d616cbeae1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Supplier_Raw",
                "status" "active",
                "created-at" "2021-07-26T15:08:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "52785746-1b7b-4e55-942f-de1f3c9c7791",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "52785746-1b7b-4e55-942f-de1f3c9c7791",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_NewWhiteLabels_Sites_Raw",
                "status" "active",
                "created-at" "2021-07-26T13:57:11Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "7b1176b1-608c-42a0-bbab-e4dfc6ae42a6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "7b1176b1-608c-42a0-bbab-e4dfc6ae42a6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Unit_Raw",
                "status" "active",
                "created-at" "2021-07-26T15:12:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2abdb0a3-34a7-438f-9dc8-a25a2b44ec26",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dc3dbeb9-55cd-4fa6-8e77-fa2cd3e0466c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-23T15:32:55Z",
                "name" "V_Dev_Traveller_Rate_Latest",
                "status" "active",
                "created-at" "2021-07-12T10:12:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "3a89c369-bc4c-4865-a36d-30a0a0fe2cbe",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "3a89c369-bc4c-4865-a36d-30a0a0fe2cbe",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Object_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:43:57Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a1c3151c-bd13-45d2-9320-45e6c1891f0f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "a1c3151c-bd13-45d2-9320-45e6c1891f0f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_ProfileHeader_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:59:36Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "24bfe14c-7f4a-45a9-a434-a0e8def27dc0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "24bfe14c-7f4a-45a9-a434-a0e8def27dc0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Calendar_Raw",
                "status" "active",
                "created-at" "2021-09-22T09:16:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "00c36ef5-2019-4661-9924-792ffc486660",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "00c36ef5-2019-4661-9924-792ffc486660",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Rate_Raw",
                "status" "active",
                "created-at" "2021-09-22T09:44:20Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "342d7f73-1456-4ca1-9f94-4c3e519e50c7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "342d7f73-1456-4ca1-9f94-4c3e519e50c7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Stock_Raw",
                "status" "active",
                "created-at" "2021-09-22T09:57:13Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "fdb08c81-c119-49a6-8c60-1a0713a23c3f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "fdb08c81-c119-49a6-8c60-1a0713a23c3f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Contract_Raw",
                "status" "active",
                "created-at" "2021-09-22T08:51:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "4ef949e8-28b2-4b87-a71c-b116f8585087",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "4ef949e8-28b2-4b87-a71c-b116f8585087",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Lookup_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:39:53Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "eabd365a-3b71-4821-8220-393a304187c1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "eabd365a-3b71-4821-8220-393a304187c1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_HolidayCottages_Regions_Raw",
                "status" "active",
                "created-at" "2021-07-26T12:21:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a422a924-9dab-442c-847e-442a31205c19",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "a422a924-9dab-442c-847e-442a31205c19",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_HolidayCottages_Towns_Raw",
                "status" "active",
                "created-at" "2021-07-26T12:28:45Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6ddd6f86-2bde-48aa-b57a-abe431dbc360",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "6ddd6f86-2bde-48aa-b57a-abe431dbc360",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Profile_Raw",
                "status" "active",
                "created-at" "2021-07-26T14:54:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "aac3816c-d8f2-4478-aec3-77cbde750ee2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "aac3816c-d8f2-4478-aec3-77cbde750ee2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_Traveller_Region_Raw",
                "status" "active",
                "created-at" "2021-07-26T15:02:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "dd1e7f64-5ad3-461c-8292-b8bbd3bfb2e6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c13969ea-a3be-4330-abf5-0ea4c202c4fa",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:20:54Z",
                "name" "V_Dev_Traveller_Stock_Latest",
                "status" "active",
                "created-at" "2021-07-12T10:35:51Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fb500fc5-1bce-441f-8151-2ca120de865f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5fab551e-b995-4737-acf2-6e83f0dd135b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:56Z",
                "name" "V_Dev_Traveller_CottagePricing_Latest",
                "status" "active",
                "created-at" "2021-07-09T13:36:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "80a72610-b5d4-4899-a70b-fbd7f16f5222",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "28439569-7033-4d3c-875e-94bf2db14ce7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:20:39Z",
                "name" "V_Dev_Traveller_Unit_Latest",
                "status" "active",
                "created-at" "2021-06-17T16:01:47Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "649a2379-32c3-4ecf-bc1d-c7036e3ef55c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "430da000-6b3e-41b9-996b-a870f6a3ec7d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:38Z",
                "name" "V_Dev_Traveller_Lookup_Latest",
                "status" "active",
                "created-at" "2021-06-18T13:12:13Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "28787310-05e3-4a22-bced-9fcbc927ea4a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4274fcff-3d25-4183-8406-d21038ee11c3",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:01Z",
                "name" "V_Dev_Traveller_Service_Latest",
                "status" "active",
                "created-at" "2021-06-17T14:49:05Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fea13310-ba3a-4cd3-a22c-1710237e71dc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b249e9cf-a3bb-4f0d-a1b4-05ce4f851323",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:27Z",
                "name" "V_Dev_Traveller_ProfileHeader_Latest",
                "status" "active",
                "created-at" "2021-06-18T14:57:53Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "bf8a5201-9bbe-4a73-94f5-6e327b207367",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "002d3457-03dd-4d23-8034-aa645847bfe2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:08Z",
                "name" "V_Dev_Traveller_Region_Latest",
                "status" "active",
                "created-at" "2021-06-18T15:30:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7d8348ab-b0ba-4a26-a6ca-80c2819f353d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "724a2868-e907-4aa5-9351-a91f38df4c80",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:21Z",
                "name" "V_Dev_Traveller_Profile_Latest",
                "status" "active",
                "created-at" "2021-06-18T14:38:36Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b0a4519d-392f-4bd1-9403-4c47cb711eff",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a584a7ff-2e2d-4ecf-b446-2a9116c4854f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:21:31Z",
                "name" "V_Dev_Traveller_Object_Latest",
                "status" "active",
                "created-at" "2021-06-18T13:28:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f1e5184c-69a2-4c52-ab71-bb49d47c7d3c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "832189f2-4400-4e65-a628-719727accc3c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:11Z",
                "name" "V_Dev_Traveller_CottagePricing_Assignment_Latest",
                "status" "active",
                "created-at" "2021-07-09T14:08:16Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7eae5efe-68a2-445a-a420-f78e367959da",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a9a2477c-17ec-4af9-977d-893484841b65",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:07Z",
                "name" "V_Dev_NewWhiteLabels_Sites_Latest",
                "status" "active",
                "created-at" "2021-06-21T08:25:19Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1ee21d58-8426-4666-9b35-bb0a7a40c1ba",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b34718bd-2fb8-470f-8420-f08ad4d79d7f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:30Z",
                "name" "V_Dev_HolidayCottages_SBWindows_Latest",
                "status" "active",
                "created-at" "2021-06-21T09:37:58Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "cdcc40b5-7ec1-4683-8d57-78e4c9d8c9f2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a416849d-7c90-4e10-9479-4c543fd12750",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:05Z",
                "name" "V_Dev_Traveller_CottagePricingBand_Latest",
                "status" "active",
                "created-at" "2021-07-09T15:09:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f25d00cf-e450-46c6-9a6d-cd624b875034",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9333ef3d-178e-46a3-93be-c0b7fb0b4da6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:18Z",
                "name" "V_Dev_Traveller_Contract_Latest",
                "status" "active",
                "created-at" "2021-07-09T13:14:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c18e774b-55e1-476b-9e92-bb950c5769a1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d1220328-bdcb-4579-91c0-f549becb391f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:14Z",
                "name" "V_Live_NewWhiteLabels_Sites_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:00:40Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "d7cbf3a1-da2d-436a-9638-a663d7bfa5a5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e9b05ae9-200f-4c87-b909-1978a307b319",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:34Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscount_Latest",
                "status" "active",
                "created-at" "2021-07-08T14:32:14Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6d7415b2-21cc-4fef-afaf-031bf7b77b81",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "aa5af257-c1a8-4a37-9dbf-de7f5a310049",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:39Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountFeatures_Latest",
                "status" "active",
                "created-at" "2021-07-08T15:22:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "8ceb33df-a20e-4891-8bc7-74aa9a4bca2c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "42ad0c41-c0e2-4302-b3f5-fc1dc72b80ba",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:46Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountAreaRegion_Latest",
                "status" "active",
                "created-at" "2021-07-08T15:10:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "36445f56-3a42-42b3-a113-e9f5d0f65c92",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fc87382e-451a-4047-945b-529749a4ac49",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:22:59Z",
                "name" "V_Dev_Traveller_Attribute_Latest",
                "status" "active",
                "created-at" "2021-06-17T13:03:49Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "4df07da5-d92b-4d7b-a68c-69e41654c8d2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "370a5dbb-3515-4da5-b129-3027087650ec",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:12Z",
                "name" "V_Dev_NewWhiteLabels_Config_Latest",
                "status" "active",
                "created-at" "2021-06-21T08:00:32Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1c4596d1-c424-44f4-88bd-b41e4e4944e4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fdb63a6b-66c1-4e3f-b098-0acb89376ea0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:25Z",
                "name" "V_Dev_HolidayCottages_SeasonalDates_Latest",
                "status" "active",
                "created-at" "2021-06-21T09:38:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "61c1a9f9-386d-4138-99c2-6dd646948461",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1676f7bf-463a-4fab-8956-4cf95154a13d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:35Z",
                "name" "V_Dev_HolidayCottages_SBLeadTimes_Latest",
                "status" "active",
                "created-at" "2021-06-21T09:37:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f872c363-0f10-4edb-a85c-6b512b45727e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "59de8bf3-47e3-466d-9277-6e63b8e23361",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:19Z",
                "name" "V_Dev_HolidayCottages_Towns_Latest",
                "status" "active",
                "created-at" "2021-06-21T08:48:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "492adbab-1c31-47e2-9d72-78b9240c2677",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3e743ab2-c0df-4496-9e83-7d66927be74c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T09:23:41Z",
                "name" "V_Dev_HolidayCottages_Regions_Latest",
                "status" "active",
                "created-at" "2021-06-21T09:00:49Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "78acc9ec-2488-440f-b60d-f6224fbf135e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3e91d3a2-9ead-4ff1-abd0-d5fd08c552e6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:00:55Z",
                "name" "V_Live_HolidayCottages_Region_Latest",
                "status" "active",
                "created-at" "2021-07-26T12:25:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e19dc2b4-85b4-4b1e-83bf-74c4b6bbcfb8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d9a16200-bb9a-417e-ad87-11c706052e51",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:02Z",
                "name" "V_Live_HolidayCottages_Towns_Latest",
                "status" "active",
                "created-at" "2021-07-26T12:36:26Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "affdd1a0-b9ba-4885-ac08-48ec03424d92",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fbaa4e44-223e-4f18-856c-7ea92cd7e569",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:26Z",
                "name" "V_Live_Traveller_Feature_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:30:19Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2445bf37-a553-4cf7-a90c-a29bb5791440",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "71546b41-6784-4439-9771-998a6f97c566",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:55Z",
                "name" "V_Live_Traveller_Profile_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:56:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "917c9c5d-03e3-4ee7-ab0a-a3900f122a93",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c7b2f99e-a9b4-43d8-bf2d-99aa1f1e2571",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:21Z",
                "name" "V_Live_Traveller_Attribute_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:13:48Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "176e7f31-0b3e-49cc-bf3a-b116814c2fd6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5148e858-a7fa-424c-bee2-ee457258169b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:32Z",
                "name" "V_Live_Traveller_Login_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:36:36Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0c617c42-7f2b-4595-b5fb-c2973da402fc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5a051a92-1c68-4e6c-a747-b16bd94ff277",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:39Z",
                "name" "V_Live_Traveller_Lookup_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:41:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "bc4cec37-4e41-43ec-9e45-52b21c7209be",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "cd13a249-9eae-43e6-aed1-4d0e9e5d049f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:49Z",
                "name" "V_Live_Traveller_ProfileHeader_Latest",
                "status" "active",
                "created-at" "2021-07-26T15:00:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "cf242ce5-2e78-43b3-ab0c-8ffeedd0dc90",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b235906d-0c4e-4151-810f-961a8b695f0d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:01:44Z",
                "name" "V_Live_Traveller_Object_Latest",
                "status" "active",
                "created-at" "2021-07-26T14:45:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "33d502a3-e9bb-4859-b4fc-ceb90df96bbc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b74362e3-bb02-43da-acec-9f12a51a4d90",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:02:11Z",
                "name" "V_Live_Traveller_Service_Latest",
                "status" "active",
                "created-at" "2021-07-26T15:06:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "b7f51f0a-efc2-4a2a-8664-837110ab6ab4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f41a08a2-c9fb-4c97-95b3-b23f68523cda",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:02:02Z",
                "name" "V_Live_Traveller_Region_Latest",
                "status" "active",
                "created-at" "2021-07-26T15:03:33Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "c125f2cd-0dc0-4707-be48-8fc0fda1f885",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b9d6decd-288a-44f4-b8c3-f7776525a1ce",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-08-24T10:02:29Z",
                "name" "V_Live_Traveller_Unit_Latest",
                "status" "active",
                "created-at" "2021-07-26T15:13:45Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "06f1ac8c-7296-44e6-a163-fc910dedec8d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dd3bcff0-53b4-4e22-a572-ab6c25ea8cf1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-05T09:05:08Z",
                "name" "V_Dev_Traveller_Login_History",
                "status" "active",
                "created-at" "2021-06-18T08:16:33Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "4f795a68-0cb6-4bd6-acf6-08aa3fb46e57",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4f795a68-0cb6-4bd6-acf6-08aa3fb46e57",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:58:50Z",
                "name" "V_Live_Traveller_Stock_History",
                "status" "active",
                "created-at" "2021-09-22T09:58:50Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "7d6bbde3-babe-401e-8454-072b0a998cbd",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7d6bbde3-babe-401e-8454-072b0a998cbd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T10:01:24Z",
                "name" "V_Live_Traveller_Stock_Latest",
                "status" "active",
                "created-at" "2021-09-22T10:01:24Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "1a04ded5-e7f7-4d88-8bb7-5c6035197a38",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "367a5598-16e8-452e-b9fd-92702afec786",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-01T11:24:50Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-01-18T12:13:16Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "11953f4f-2296-462e-9220-c5fd1bee541b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "11953f4f-2296-462e-9220-c5fd1bee541b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-09-27T12:25:31Z",
                "name" "V_Live_HolidayCottages_SBLeadTimes_Raw",
                "status" "active",
                "created-at" "2021-09-22T08:45:45Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e55dcc27-cb32-41d9-b910-e6f4605ebc48",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e55dcc27-cb32-41d9-b910-e6f4605ebc48",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T08:46:46Z",
                "name" "V_Live_HolidayCottages_SBLeadTimes_History",
                "status" "active",
                "created-at" "2021-09-22T08:46:46Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "40d20cca-265e-4ad4-8cc6-349807fa816f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "40d20cca-265e-4ad4-8cc6-349807fa816f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T08:47:42Z",
                "name" "V_Live_HolidayCottages_SBLeadTimes_Latest",
                "status" "active",
                "created-at" "2021-09-22T08:47:42Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a4022cf3-a6af-4697-aa3e-3b01f198c527",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a4022cf3-a6af-4697-aa3e-3b01f198c527",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:50:15Z",
                "name" "V_Live_Traveller_Rate_History",
                "status" "active",
                "created-at" "2021-09-22T09:50:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "9bd9e647-ba15-41db-97ea-2cc4ab849731",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9bd9e647-ba15-41db-97ea-2cc4ab849731",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-09-22T09:55:18Z",
                "name" "V_Live_Traveller_Rate_Latest",
                "status" "active",
                "created-at" "2021-09-22T09:55:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "5e1e02db-a43e-400b-aa4c-fcba66ec196a",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "ae559ef2-8131-4883-a785-b272520ae6b2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-21T14:26:48Z",
                "name" "Dev_Dim_Property_Operation_Feature_Load_Data",
                "status" "active",
                "created-at" "2021-06-25T13:09:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "78bf4910-8adf-4eae-b3d8-520ac86abcb5",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "6623ce63-7c3e-4533-8812-6c09142e725a",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:09:03Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:08:53Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4760b0bd-1a23-4fa0-ac5e-625898c2c08e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5640d256-7f57-4f15-88f5-5ddb22f5597b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-21T15:33:36Z",
                "name" "V_Dev_Dim_Property_Operation_Feature_Source",
                "status" "active",
                "created-at" "2021-06-23T12:59:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "07e37101-4b29-4cee-a85f-774b78d36578",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "26848a76-b2b9-4f3c-924b-037392128b87",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-18T08:24:58Z",
                "name" "V_Live_Dim_Property_Marketing_Feature_Source",
                "status" "active",
                "created-at" "2021-07-27T10:23:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "4579e8ad-7b64-4f57-9d72-0acceb6422fb",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [













                ],
                "tags" [],
                "dow" nil,
                "id" "041ee361-9b7a-42d4-b5fc-f904f74bf9c0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-18T12:42:06Z",
                "name" "Dev_Fact_Pricing_Load_Data",
                "status" "active",
                "created-at" "2021-07-20T14:27:42Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "a6621453-e1f3-4c13-bd23-a7ac684eecd6",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [













                ],
                "tags" [],
                "dow" nil,
                "id" "dcca3830-653b-4899-985b-4944fb9d026c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-10-19T09:39:19Z",
                "name" "Live_Fact_Pricing_Load_Data",
                "status" "active",
                "created-at" "2021-09-22T12:49:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6d57b622-b92c-44a8-9f67-357edf64f609",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6d57b622-b92c-44a8-9f67-357edf64f609",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:11:24Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_AD_1MONTH_RAW",
                "status" "active",
                "created-at" "2022-04-04T15:11:24Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ed97392c-49c7-4274-9d3e-128d08a95bcf",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6424c3ee-76f0-4d43-a7bc-6dc3cd30acc1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-22T10:08:09Z",
                "name" "V_Live_Dim_Property_Brand_Source",
                "status" "active",
                "created-at" "2021-07-27T10:05:56Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [





                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "39a18eef-7be2-421a-a670-dc45c51a7f03",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5f00e2d1-13dc-4491-a6c0-da9fa10b3285",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-11-01T10:32:49Z",
                "name" "V_Dev_Dim_Discount_Source",
                "status" "active",
                "created-at" "2021-10-20T10:20:09Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "290290f6-ca00-43b9-bfd7-82d3476be47d",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "290290f6-ca00-43b9-bfd7-82d3476be47d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-10-26T15:02:32Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS",
                "status" "active",
                "created-at" "2021-10-26T15:02:32Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "8aa482f9-50e5-4eb3-b80e-f3a27b9abf28"
            },
            {
                "master-id" "4aaa5b3b-3bd4-4dc6-8c96-7180d762c52d",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "b7f90058-b426-475c-bb8f-f677a510e323",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_CAMPAIGN_1MONTH_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:57:00Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "064a6e17-4a6d-4e63-bdf9-dad889e30d71",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "064a6e17-4a6d-4e63-bdf9-dad889e30d71",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.BIGQUERY_GA_DAILYHITSPAGEVIEWSTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:17:08Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "16a078c8-5f92-46ce-a6dc-eec7570440c7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "16a078c8-5f92-46ce-a6dc-eec7570440c7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-12-09T11:07:31Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscount_Raw",
                "status" "active",
                "created-at" "2021-12-09T11:07:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "f667f722-4c8a-41be-a9e9-bad1a182ffc7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f667f722-4c8a-41be-a9e9-bad1a182ffc7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:08:27Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscount_History",
                "status" "active",
                "created-at" "2021-12-09T11:08:27Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "d56cc809-b111-4ae1-80cb-9bbcaa1b163c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d56cc809-b111-4ae1-80cb-9bbcaa1b163c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:09:17Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscount_Latest",
                "status" "active",
                "created-at" "2021-12-09T11:09:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "b31d4ffb-a135-4549-a735-5876d779efdd",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "b31d4ffb-a135-4549-a735-5876d779efdd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2021-12-09T11:13:03Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscountProperties_Raw",
                "status" "active",
                "created-at" "2021-12-09T11:13:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e8905e89-f268-4660-94be-ae77032cb3b8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9768779e-7bf0-4518-930f-64007dfa20c8",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:15:22Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscountProperties_History",
                "status" "active",
                "created-at" "2021-12-09T11:15:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "dc3692a9-4b85-4ef7-8cef-805c8f34f3b4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dc3692a9-4b85-4ef7-8cef-805c8f34f3b4",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:16:55Z",
                "name" "V_Live_Traveller_CampaignPropertyDiscountProperties_Latest",
                "status" "active",
                "created-at" "2021-12-09T11:16:55Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "7e6dc5dc-7b89-42cb-aba3-9c533195d881",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7e6dc5dc-7b89-42cb-aba3-9c533195d881",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:18:16Z",
                "name" "V_Live_Dim_Discount_Source",
                "status" "active",
                "created-at" "2021-12-09T11:18:16Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2d9faf19-6936-4cca-83be-eaa4b55c8107",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "2d9faf19-6936-4cca-83be-eaa4b55c8107",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-09T11:20:57Z",
                "name" "Live_Dim_Discount_Load_Data",
                "status" "active",
                "created-at" "2021-12-09T11:20:57Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2cbf8bcb-d5b6-40c7-9ee8-913918e7fe81",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2934025c-e054-4123-9373-1f481bfe2556",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_HolidayCottages_SeasonalDates_Raw",
                "status" "active",
                "created-at" "2021-06-21T09:18:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "9d1495ec-bb8b-4626-9058-b02a48879fde",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f1c32067-b602-4a36-bef4-96a1aefe6f30",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_Calendar_Raw",
                "status" "active",
                "created-at" "2021-07-08T10:21:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "a01d1584-d2b9-4438-b5b5-dfbc06523e12",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "380451bc-e4c2-4d4b-9207-e59d6a6bf386",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountAreaRegion_Raw",
                "status" "active",
                "created-at" "2021-07-08T14:45:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c0f53604-251a-465d-80e6-e595e1aadebb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ceb4c472-4169-4c95-8013-15eabf1d23cb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountFeatures_Raw",
                "status" "active",
                "created-at" "2021-07-08T15:20:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c00e8037-dcac-4776-8702-7afa69a9221d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c00e8037-dcac-4776-8702-7afa69a9221d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CottagePricingAssignment_Raw",
                "status" "active",
                "created-at" "2021-07-09T14:02:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "15bbf552-a570-47f8-b5ab-1205bc9ecdeb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "15bbf552-a570-47f8-b5ab-1205bc9ecdeb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CottagePricingCode_Raw",
                "status" "active",
                "created-at" "2021-07-09T15:29:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7f4d6a9e-c100-4757-9f4f-e809d00b4415",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "41800b8c-dc00-47d1-b39c-f150970e9d68",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_HolidayCottages_Towns_Raw",
                "status" "active",
                "created-at" "2021-06-21T08:27:25Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c168e1c3-7bae-47e7-a1a7-5506856a0ae9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "136dc57b-2864-40c1-82ae-f3316456b4dc",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_NewWhiteLabels_Sites_Raw",
                "status" "active",
                "created-at" "2021-06-21T08:10:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c53e21f4-5590-4aaf-b1b8-0ceebf5fddfe",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "72a55c5d-67b9-4e41-a490-f7c547b7e7be",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscountProperties_Raw",
                "status" "active",
                "created-at" "2021-07-08T15:29:16Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b9d4bdb8-16a8-44c2-9a76-9741230ed310",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b9d4bdb8-16a8-44c2-9a76-9741230ed310",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CottagePricing_Raw",
                "status" "active",
                "created-at" "2021-07-09T13:23:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "75ee6abd-99da-49fd-bbbd-54fddcc88a3a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "577c8e97-4b23-4938-86d4-6c0801b1c711",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_HolidayCottages_SBLeadTimes_Raw",
                "status" "active",
                "created-at" "2021-06-21T09:16:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "0b7f6a63-bc6c-4f57-a902-24fda13451c9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ac63908c-9f40-452e-8e65-d25be3bd21bf",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_HolidayCottages_SBWindows_Raw",
                "status" "active",
                "created-at" "2021-06-21T09:17:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e87925a7-6ffd-4994-bb9c-6524d37e2def",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3c9cc7ae-06c1-4c78-bf81-d561aa48a5cb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CampaignPropertyDiscount_Raw",
                "status" "active",
                "created-at" "2021-07-08T14:14:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "3543ced8-ae4e-4665-996d-93934eaa6c1f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3543ced8-ae4e-4665-996d-93934eaa6c1f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_Stock_Raw",
                "status" "active",
                "created-at" "2021-07-12T10:27:45Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "ad832091-29b8-4e2b-bc02-afdeb2b45093",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "04c60091-35ca-4401-a9a4-194f728417ea",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_CottagePricingBand_Raw",
                "status" "active",
                "created-at" "2021-07-09T15:05:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "164c17a3-3e95-42bf-8315-8837267e56a0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "78490cde-1e1f-4ea9-bd84-d99f9e4d9797",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_NewWhiteLabels_Config_Raw",
                "status" "active",
                "created-at" "2021-06-21T07:51:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "dbad8eb9-b369-46d9-8b95-40fed48b4523",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3d35ed06-c75b-4458-b703-4d7467b5c928",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_HolidayCottages_Regions_Raw",
                "status" "active",
                "created-at" "2021-06-21T08:53:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6d541b11-354b-44a3-ab2c-573ec8f5fd9e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1168856f-eab8-4def-8ec0-37964fa4fbcd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-01T10:59:54Z",
                "name" "V_Dev_Traveller_Supplier_Raw",
                "status" "active",
                "created-at" "2021-06-18T15:32:02Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f11807dd-05c3-407d-9302-46f1c575ac49",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "f11807dd-05c3-407d-9302-46f1c575ac49",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-03-22T13:53:17Z",
                "name" "V_Live_Traveller_CleaningCharges_Raw",
                "status" "active",
                "created-at" "2022-03-22T13:53:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "43fe941f-0e9d-493b-b47e-93b9223ad4a6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "43fe941f-0e9d-493b-b47e-93b9223ad4a6",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-03-22T13:58:04Z",
                "name" "V_Live_Traveller_Voucher_Raw",
                "status" "active",
                "created-at" "2022-03-22T13:58:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "9333dab7-214f-4c62-89e5-91f7d02b44d1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9333dab7-214f-4c62-89e5-91f7d02b44d1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T13:54:18Z",
                "name" "V_Live_Traveller_CleaningCharges_History",
                "status" "active",
                "created-at" "2022-03-22T13:54:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "3ee994f9-e917-4a2f-a624-724fdf71ef3d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3ee994f9-e917-4a2f-a624-724fdf71ef3d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T13:58:41Z",
                "name" "V_Live_Traveller_Voucher_History",
                "status" "active",
                "created-at" "2022-03-22T13:58:41Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "31a8bbf0-c664-4eb3-905d-59ad0568b354",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "fb97630a-1fab-4b26-9730-cc568bbb165b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-14T09:44:50Z",
                "name" "Dev_Dim_Property_Brand_Load_Data",
                "status" "active",
                "created-at" "2021-06-21T10:04:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "826f4907-3062-49b5-b956-21cabc94bc56",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "826f4907-3062-49b5-b956-21cabc94bc56",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-02T14:51:44Z",
                "name" "V_Dev_TravelChapter_Data_Brands_Raw",
                "status" "active",
                "created-at" "2022-02-02T14:51:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "bd7af120-4b3c-4cac-83e4-fb25cb931903",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bd7af120-4b3c-4cac-83e4-fb25cb931903",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:02:46Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T17:02:46Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "9f93677e-921b-4d65-9cf2-5bcd1c3cf330",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "94e8e32c-a2fd-4dc7-aad4-190f791a8a0e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-02T14:39:10Z",
                "name" "V_Live_Fact_Pricing_Source",
                "status" "active",
                "created-at" "2021-09-22T12:12:25Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [





                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "afd48780-aaab-437e-9900-4c713d9b2493",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fd5e694c-e680-4d73-ba0b-397bbd12044b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-02T15:03:28Z",
                "name" "V_Dev_TravelChapter_Data_Brands_History",
                "status" "active",
                "created-at" "2022-02-02T15:01:27Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "11b830c5-44b7-4bef-9fd8-4e3c1187533b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "11b830c5-44b7-4bef-9fd8-4e3c1187533b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-02T15:06:54Z",
                "name" "V_Dev_TravelChapter_Data_Brands_Latest",
                "status" "active",
                "created-at" "2022-02-02T15:06:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6679e0c4-48d0-4752-86a9-5b6b245e9196",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6679e0c4-48d0-4752-86a9-5b6b245e9196",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:11:22Z",
                "name" "V_Dev_Traveller_Supplier_History_Secure",
                "status" "active",
                "created-at" "2022-01-19T10:11:22Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7302de75-5058-48aa-a6fc-268ff8bccf79",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7302de75-5058-48aa-a6fc-268ff8bccf79",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:22:29Z",
                "name" "V_Dev_Traveller_Supplier_Latest_Secure",
                "status" "active",
                "created-at" "2022-01-19T10:22:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e96f423d-8814-4d93-9156-50b821159bb3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ac1797da-4bd8-48da-b520-172462968a48",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:48:18Z",
                "name" "V_Dev_Traveller_Attribute_Raw",
                "status" "active",
                "created-at" "2021-06-17T09:08:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b4fabf0e-00c2-4ad4-b7cd-246d94e45dd4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "09629de6-c4e3-472d-a88a-069bc12e0fb3",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:49:47Z",
                "name" "V_Dev_Traveller_Feature_Raw",
                "status" "active",
                "created-at" "2021-06-17T09:09:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "2be19978-8632-4b97-b6cf-7910b90864b0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f4e90888-b3b5-4488-8e22-0827a4c05844",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:49:53Z",
                "name" "V_Dev_Traveller_Lookup_Raw",
                "status" "active",
                "created-at" "2021-06-18T09:07:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fa5b41f5-b76b-461a-a2a1-13a9a4334b4e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ace48f90-9ab9-49e4-8e46-ad63903a0362",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:49:49Z",
                "name" "V_Dev_Traveller_Login_Raw",
                "status" "active",
                "created-at" "2021-06-18T08:00:07Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "a6e05d7f-550f-48aa-8e40-d4d6168c4c67",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4e5bb760-0800-47a2-9d67-15a9bd4a169d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:49:59Z",
                "name" "V_Dev_Traveller_Object_Raw",
                "status" "active",
                "created-at" "2021-06-18T13:20:22Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "4d7ba8dd-bf4f-461e-b58f-5f7618ede738",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "324bd1ce-8a96-4092-ad93-baf2b4eb7b96",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:50:07Z",
                "name" "V_Dev_Traveller_ProfileHeader_Raw",
                "status" "active",
                "created-at" "2021-06-18T14:47:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "688a4dc0-4353-4bac-b04b-b82a8aacc5e1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "85c2293f-4c08-4471-b1d3-7f54f7efa58e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:50:24Z",
                "name" "V_Dev_Traveller_Region_Raw",
                "status" "active",
                "created-at" "2021-06-18T15:06:48Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "68206e15-4f1a-49ac-9765-9935d0952813",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "28b2906e-342e-4912-a897-f28dd84c80a9",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:50:43Z",
                "name" "V_Dev_Traveller_Unit_Raw",
                "status" "active",
                "created-at" "2021-06-17T15:37:33Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1b88d621-9dc5-4791-a827-401b32ca9ca0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "aca5f447-c432-464a-9ec5-9c913a565d4b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:50:15Z",
                "name" "V_Dev_Traveller_Profile_Raw",
                "status" "active",
                "created-at" "2021-06-18T14:32:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1cc85add-0eb1-4bd4-a782-05f60b759c2b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9fdde151-d046-4113-81f1-4152fa1ba665",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-17T15:50:32Z",
                "name" "V_Dev_Traveller_Service_Raw",
                "status" "active",
                "created-at" "2021-06-17T14:47:57Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "43836039-887a-4319-a202-be0129394410",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "282814da-7ef1-4f1b-b45c-624e0f811401",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-21T08:52:15Z",
                "name" "V_Dev_Dim_Property_Brand_Source",
                "status" "active",
                "created-at" "2021-06-21T09:55:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [





                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "93e2ca0c-de0c-4182-9d2a-cdadca76bca5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "23f7cf0a-8338-458c-9853-83f05bbf3407",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T16:11:40Z",
                "name" "V_Dev_Traveller_CleaningCharges_Latest",
                "status" "active",
                "created-at" "2022-03-18T14:34:26Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "9c0cba02-5dbe-4941-a955-4e7740b4571c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "542c61d1-fb43-4a53-97ee-3e3a4cc55d08",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T16:11:54Z",
                "name" "V_Dev_Traveller_Voucher_Latest",
                "status" "active",
                "created-at" "2022-03-16T15:34:21Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e503158f-89e7-40ab-bba8-4ce5161a61f0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "255e0107-b4ee-4eb7-9c54-dbbfbbb31c71",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T16:12:48Z",
                "name" "V_Live_Traveller_CleaningCharges_Latest",
                "status" "active",
                "created-at" "2022-03-22T13:56:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "703bae81-62c9-443b-9b4e-231e90acf7ff",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "be03a6ca-1d2a-4ff5-b158-47ac017579fb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:25:19Z",
                "name" "V_Dev_Traveller_Supplier_History",
                "status" "active",
                "created-at" "2021-06-18T15:52:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e9f102ab-5b02-40a8-be92-2e866fc2a061",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a1c39b09-c37c-435a-bb21-642df4f16d8a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-22T16:13:04Z",
                "name" "V_Live_Traveller_Voucher_Latest",
                "status" "active",
                "created-at" "2022-03-22T13:59:34Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a7777167-aceb-4869-b8ca-1b33c921393f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b0f45ab2-ae90-4bb3-b36a-759ae8bf74dd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:28:59Z",
                "name" "V_Dev_Traveller_Supplier_Latest",
                "status" "active",
                "created-at" "2021-06-18T16:10:54Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "77e43dd3-6612-4d85-a9a3-e8e1824ef2ba",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "214e6f6e-1898-4ea3-b79d-6be67c1e0274",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:36:49Z",
                "name" "V_Dev_Property",
                "status" "active",
                "created-at" "2021-06-21T07:38:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [









                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "400b463d-b8dc-4d1a-9f22-df8b921eae0b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "400b463d-b8dc-4d1a-9f22-df8b921eae0b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T09:53:52Z",
                "name" "V_Live_Traveller_Supplier_Latest_Secure",
                "status" "active",
                "created-at" "2022-01-24T09:53:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "29907994-b726-4fd6-9cfd-b03786936070",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fa02eafb-88e8-4eaf-b21e-b7709fefbc82",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:37:00Z",
                "name" "V_Dev_Property_Discount_Week",
                "status" "active",
                "created-at" "2021-11-05T15:54:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "74f0e51c-bc82-4e10-8e26-928ae1df4769",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2ef810e0-2efa-4eb8-99dd-077b86c83f93",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:37:24Z",
                "name" "V_Dev_Property_Feature",
                "status" "active",
                "created-at" "2021-06-17T09:17:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "3c494933-6591-444e-88a2-09c57a743bd1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "63babd79-60e3-4902-8999-1387200729d1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:38:06Z",
                "name" "V_Dev_Property_On_HolidayCottages",
                "status" "active",
                "created-at" "2021-12-20T15:31:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [












                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "3e1386ae-274e-402c-bd86-31903f48b708",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [



                ],
                "tags" [],
                "dow" nil,
                "id" "0036a250-813b-4b2e-9d0a-549c4397caab",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-19T10:41:57Z",
                "name" "V_Dev_Standard_Pricing",
                "status" "active",
                "created-at" "2021-07-16T13:10:18Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [















                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "09d21781-de5d-4eba-9d31-0ffe686e1ee0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "09d21781-de5d-4eba-9d31-0ffe686e1ee0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-06T11:31:42Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_YOY",
                "status" "active",
                "created-at" "2021-12-06T11:31:42Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "3a75da5d-7c1d-4ef1-af1e-3e89c3ffc2f2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3a75da5d-7c1d-4ef1-af1e-3e89c3ffc2f2",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-06T11:35:54Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_3YA",
                "status" "active",
                "created-at" "2021-12-06T11:35:54Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "b6080122-4d85-4369-92f8-628ba87be26e",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "375d8ace-7ead-4ed5-ad09-6bf616797438",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-07T11:07:53Z",
                "name" "PROD.DEV_STAGING.FB_ADS_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2021-12-06T20:10:40Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "af3cd89c-2ccf-48dc-99b6-0e40d77f5773",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "489568f4-d619-423c-a77b-ba3f60cf88f5",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-07T11:47:25Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2021-12-07T11:46:39Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "54790eb7-50e2-443e-a47b-bd2101bc3aad",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "54790eb7-50e2-443e-a47b-bd2101bc3aad",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-07T11:45:20Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_ENTITY",
                "status" "active",
                "created-at" "2021-12-07T11:45:20Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "32b92b2d-a7c1-4844-a706-3a7ec11dd973",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "32b92b2d-a7c1-4844-a706-3a7ec11dd973",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2021-12-07T12:03:05Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_ENTITY",
                "status" "active",
                "created-at" "2021-12-07T12:03:05Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "96631ddd-b482-41ad-acd3-c68b2b2b1f37",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [










                ],
                "tags" [],
                "dow" nil,
                "id" "c85e13bd-65ee-46c6-b6e5-b5f948f7b051",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-22T10:11:11Z",
                "name" "Live_Dim_Property_Brand_Load_Data",
                "status" "active",
                "created-at" "2021-07-27T11:49:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0e474366-b6f5-4549-8a85-3e2fa3f0871a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "cd814cd8-f8df-4cb3-877d-f3dd092dcabd",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-23T15:21:08Z",
                "name" "V_Dev_Traveller_Booking_History",
                "status" "active",
                "created-at" "2021-12-23T15:17:39Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "db68c590-fa60-4b73-92a9-88feb7c75eec",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "db68c590-fa60-4b73-92a9-88feb7c75eec",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2021-12-23T15:25:03Z",
                "name" "V_Dev_Traveller_Details_Raw",
                "status" "active",
                "created-at" "2021-12-23T15:25:03Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "1d309800-ceac-497e-a204-8b99063538ae",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1d309800-ceac-497e-a204-8b99063538ae",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-03T15:19:59Z",
                "name" "V_Dev_TravelChapter_Data_LawfulBasis_Raw",
                "status" "active",
                "created-at" "2022-02-03T15:19:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6eca19e6-029b-4e01-9b00-b23dbe089a85",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6eca19e6-029b-4e01-9b00-b23dbe089a85",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-03T15:20:56Z",
                "name" "V_Dev_TravelChapter_Data_LawfulBasis_History",
                "status" "active",
                "created-at" "2022-02-03T15:20:56Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "9f339f60-2773-4515-983c-b18169c63601",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1b0ffc7b-c788-42e4-916a-9a60b929db88",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-17T15:07:45Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2021-12-07T12:04:44Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "70169f7c-7af8-40af-ae4b-16a1902d64f7",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "70169f7c-7af8-40af-ae4b-16a1902d64f7",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-03T15:28:51Z",
                "name" "V_Dev_TravelChapter_Data_LawfulBasis_Latest",
                "status" "active",
                "created-at" "2022-02-03T15:28:51Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "97bf3624-21dc-4367-8edb-cc4b7992f1db",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "97bf3624-21dc-4367-8edb-cc4b7992f1db",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-20T10:02:26Z",
                "name" "V_Dev_Traveller_Client_Raw",
                "status" "active",
                "created-at" "2022-01-20T10:02:26Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "d67fd2fa-cce4-44b7-97fd-3ff1828350fc",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "93d46f64-a753-4ec4-a0ae-303b56d127ca",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-01-17T17:34:15Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "4c929332-eed3-4d2f-abf5-3db2a177397c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4c929332-eed3-4d2f-abf5-3db2a177397c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T10:02:41Z",
                "name" "V_Dev_Booking_Feature_Secure",
                "status" "active",
                "created-at" "2022-02-04T10:02:41Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "dad1ccf1-7e6b-4ca9-aa00-83b35cd04b75",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dad1ccf1-7e6b-4ca9-aa00-83b35cd04b75",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T11:43:44Z",
                "name" "V_Dev_TravelChapter_Data_OptInPermissions_Raw",
                "status" "active",
                "created-at" "2022-02-04T11:43:44Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "93303de6-dc27-4cad-9eba-c835f77dcbd2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "93303de6-dc27-4cad-9eba-c835f77dcbd2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T09:13:33Z",
                "name" "V_Dev_Traveller_Itinerary_Raw",
                "status" "active",
                "created-at" "2022-01-11T09:13:33Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "d98cd673-ef99-43c0-926e-1d08561977c9",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d9f6f14e-2878-4465-a243-e3ad9bec2dbc",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-25T15:27:29Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_ENTITY",
                "status" "active",
                "created-at" "2022-03-11T10:01:04Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "703cc1f4-2675-43a2-b6b9-b154af01c888",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5689944b-ef35-4f70-97d0-59ce7f6e86ec",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T09:39:20Z",
                "name" "V_Dev_Traveller_Itinerary_History",
                "status" "active",
                "created-at" "2022-01-11T09:32:41Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fef3b1ed-d9bb-4a5d-975b-6db4276ec4cc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d3c98306-b531-435c-8262-884a90722cb9",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T09:42:19Z",
                "name" "V_Dev_Traveller_Booking_Latest",
                "status" "active",
                "created-at" "2021-12-23T15:23:16Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b2dc8052-02a8-43b0-8052-0d3b59e8ec14",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b2dc8052-02a8-43b0-8052-0d3b59e8ec14",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T09:41:37Z",
                "name" "V_Dev_Traveller_Itinerary_Latest",
                "status" "active",
                "created-at" "2022-01-11T09:41:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "189e99fa-6c01-4bc4-9742-2744a8ccc22e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9e72f8fa-6943-4c27-a80a-4dd2cdf03ab0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T10:08:54Z",
                "name" "V_Dev_Traveller_Details_History",
                "status" "active",
                "created-at" "2022-01-11T10:08:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "64790dba-55c7-4853-b98b-3cb847a2172a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "64790dba-55c7-4853-b98b-3cb847a2172a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T10:09:59Z",
                "name" "V_Dev_Traveller_Details_Latest",
                "status" "active",
                "created-at" "2022-01-11T10:09:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "cfcaa874-3706-42f8-b73a-cfb6e06e598f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8f51ac6e-7027-48e2-807c-7c8ceba7fb76",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T10:10:49Z",
                "name" "V_Dev_Traveller_Details_History_Secure",
                "status" "active",
                "created-at" "2021-12-31T10:49:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "83a51d33-3696-4865-a371-ffca64a7a01b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bb189f36-61b8-4cbb-bf0b-d2ad757d0ae3",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-11T10:11:03Z",
                "name" "V_Dev_Traveller_Details_Latest_Secure",
                "status" "active",
                "created-at" "2021-12-31T10:55:29Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "27e3e278-50ef-4800-baa8-d13a70d9672f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d50ccc2d-92a3-4432-813c-b0c01855d819",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-19T10:00:11Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_2YA",
                "status" "active",
                "created-at" "2021-12-06T11:34:41Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "e851697e-cbb1-4bb7-9bc5-7c984474e351",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "21cf1a9a-24f4-47d5-84b0-d5dd16e99fbc",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-20T10:45:12Z",
                "name" "V_Dev_Traveller_Client_History_Secure",
                "status" "active",
                "created-at" "2022-01-20T10:24:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "ef6dddc7-bae5-4581-95a9-03f4b7841d7c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ef6dddc7-bae5-4581-95a9-03f4b7841d7c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T16:27:59Z",
                "name" "V_Dev_TravelChapter_Data_OptInPermissions_History_Secure",
                "status" "active",
                "created-at" "2022-02-04T16:27:59Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "134ff85a-6036-4cef-946a-97a426e40afc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "19c05f5c-9349-49d3-8826-a658789dfa3b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T16:28:59Z",
                "name" "V_Dev_TravelChapter_Data_OptInPermissions_History",
                "status" "active",
                "created-at" "2022-02-04T11:48:09Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "23be6b42-bd9a-4d67-982c-9da4bc26e2ba",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8afa3b13-f973-437b-aa67-905536bd2109",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T16:32:07Z",
                "name" "V_Dev_TravelChapter_Data_OptInPermissions_Latest_Secure",
                "status" "active",
                "created-at" "2022-02-04T16:25:48Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "84b4d40e-4564-44d8-88da-a250e4bc4f18",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c1c23f47-3af3-40b1-ad3f-434103f1dc8e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-04T16:30:52Z",
                "name" "V_Dev_TravelChapter_Data_OptInPermissions_Latest",
                "status" "active",
                "created-at" "2022-02-04T11:52:00Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f587bf18-f4bc-426e-9b52-ce9952fbe373",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4d321ab4-f121-4e2b-94b1-7fa70e2fc2da",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-21T14:53:31Z",
                "name" "V_Dev_Traveller_Client_History",
                "status" "active",
                "created-at" "2022-01-20T15:00:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "61a7bd9b-cd7c-4492-9b88-e7a80dba6d7a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "61a7bd9b-cd7c-4492-9b88-e7a80dba6d7a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-21T14:54:11Z",
                "name" "V_Dev_Traveller_Client_Latest",
                "status" "active",
                "created-at" "2022-01-21T14:54:11Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "a2303d73-bdae-4df7-9c42-3ad1e68f3679",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "342ca34a-165e-483c-9eb8-7a8f2bafd609",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-21T14:58:07Z",
                "name" "V_Dev_Traveller_Client_Latest_Secure",
                "status" "active",
                "created-at" "2022-01-21T14:45:56Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b2e389d5-de14-4d57-b796-3fa7662ea8ae",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b2e389d5-de14-4d57-b796-3fa7662ea8ae",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T09:40:37Z",
                "name" "V_Live_Traveller_Supplier_History_Secure",
                "status" "active",
                "created-at" "2022-01-24T09:40:37Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "58773acd-c5e5-43a7-a08f-e7acacee7fdb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "58773acd-c5e5-43a7-a08f-e7acacee7fdb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T09:52:27Z",
                "name" "V_Live_Traveller_Supplier_History",
                "status" "active",
                "created-at" "2022-01-24T09:52:27Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "d85be683-0dc8-454d-83f2-b0f66a009e30",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9bbdd9f3-f0e4-49b3-a3f5-884bcdd6b4eb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:02:25Z",
                "name" "V_Live_Traveller_Supplier_Latest",
                "status" "active",
                "created-at" "2021-07-26T15:10:17Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "64e2b404-a3ce-46f0-8cbe-f7252eea3e29",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fd2a4c28-94da-47e4-a690-e1913c21162d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:08:28Z",
                "name" "V_Live_Property",
                "status" "active",
                "created-at" "2021-07-27T09:39:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [









                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "a2a6f391-30d4-4b7a-b0f7-a099511afb2f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "58fe8459-39d4-4826-95bc-9691f2184301",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:09:19Z",
                "name" "V_Live_Property_Feature",
                "status" "active",
                "created-at" "2021-07-27T09:42:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "8ed99b84-4209-454c-bc26-49b4c8f3c0f8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "27d0b887-a1cb-4255-a14a-a111cc1ca991",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:10:43Z",
                "name" "V_Live_Property_On_HolidayCottages",
                "status" "active",
                "created-at" "2021-12-22T09:56:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [












                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "420e6230-be5c-4f83-8fb5-8601a5237a11",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "132955bb-2c03-4b06-b9ac-5b69f3648891",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:13:47Z",
                "name" "V_Live_Property_Discount_Week",
                "status" "active",
                "created-at" "2021-12-09T11:22:35Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "47809c64-59a5-4b10-ad86-04da5f23a666",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [



                ],
                "tags" [],
                "dow" nil,
                "id" "c39f248d-c6d1-4c7b-8acd-9efdf5ec61de",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-24T10:14:49Z",
                "name" "V_Live_Standard_Pricing",
                "status" "active",
                "created-at" "2021-09-22T11:07:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [















                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "75fd4e4b-683e-4d7c-a1ba-c93fadb644c2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f543a8ee-2c46-4701-8266-69c8d2b59b41",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T10:45:37Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH_YOY",
                "status" "active",
                "created-at" "2021-12-06T10:58:52Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "78c5fee6-8464-4a71-8c80-61ab04d29012",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "63ac3c49-c1d3-4169-ad40-dbef1b3387f2",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T10:54:41Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYSYOY",
                "status" "active",
                "created-at" "2021-11-29T14:09:49Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "e98be746-8ecb-47a5-b67e-4a6990f4f8a0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "482f62bc-b4fb-4390-8299-8f476a0f731d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T10:53:46Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS",
                "status" "active",
                "created-at" "2021-11-15T17:16:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "26340c34-b56a-4e10-9176-ac43d2b9a183",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "936bbff1-5f55-4c13-ab73-cf6d8e05dc42",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T10:54:20Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS2YA",
                "status" "active",
                "created-at" "2021-11-16T13:49:17Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "a939ad6b-a3f3-4577-bc15-db84d6f475e8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d86b34cf-b9a3-476b-98ae-627f07224a3a",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T10:54:30Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS3YA",
                "status" "active",
                "created-at" "2021-11-29T14:07:39Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "d24f6d5b-c2f2-4fd3-a1ea-006c2bcec1ed",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "de8ac11d-f7f6-4e59-90a7-1b0e69d84e89",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T14:17:26Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_MONTHLY",
                "status" "active",
                "created-at" "2021-11-29T14:43:41Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "53d914e6-c65a-42a0-af90-e644f368a776",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7348c481-ea88-4e6b-a21d-59f5cdfc33c0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T14:20:58Z",
                "name" "PROD.DEV_STAGING.GA_RAGA_MONTHLY",
                "status" "active",
                "created-at" "2021-12-06T11:43:08Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "2ac10ec3-6f9f-4b1a-bd76-acb4ae3f6d79",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3343d1b2-7289-443c-8ae5-d4bc3a658cb6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T14:56:57Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY_YOY",
                "status" "active",
                "created-at" "2021-12-06T11:54:57Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "97b05c2e-0045-459b-8a0a-6c5fa9359a08",
                "ignore-parser" true,
                
                "output-tables" [],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e21d49e0-b45a-4bad-8610-cb30f0827fa4",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T15:02:28Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_DOMAIN",
                "status" "active",
                "created-at" "2022-01-17T14:57:53Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "16aa82c4-0076-469a-9afc-1b2463cec961",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "22fada47-1b8d-462d-ae9b-9565b329761f",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T15:02:30Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_DOMAIN",
                "status" "active",
                "created-at" "2021-12-20T17:47:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "0b568b86-f821-4230-a47c-d011adae1f54",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "aedfc713-62b8-4098-943e-a4621d9d0688",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-01-24T15:02:33Z",
                "name" "PROD.DEV_STAGING.FB_AD_DOMAIN",
                "status" "active",
                "created-at" "2022-01-17T14:34:36Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "30bce7c9-718b-4c7c-9e7e-b724c81e1fe8",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0efb2ac3-3a9f-406c-8afc-5a475bdfde66",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-07T09:26:39Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH_2YA",
                "status" "active",
                "created-at" "2021-12-06T10:56:16Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "072c47dd-de25-4499-8b7c-b154133f73d7",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "523c6520-07c0-44b2-8ed8-d7096401d594",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-25T15:42:17Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_DOMAIN",
                "status" "active",
                "created-at" "2022-02-23T17:01:04Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "3e6c8366-63e9-4862-ae00-68b8bc290170",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "957085c1-f292-4a94-8052-dc174e9602c2",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-23T13:52:11Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_AGENTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T11:47:19Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "3e67e617-a7b5-4960-887e-948b6e869c0b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3e67e617-a7b5-4960-887e-948b6e869c0b",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-23T14:09:09Z",
                "name" "V_Dev_Traveller_Quote_Raw",
                "status" "active",
                "created-at" "2022-03-23T14:09:09Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b6ae5e3e-2f93-479f-806d-ea8fd1c4cdb0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "205af4c1-1000-49ab-830d-a7fd967ce20d",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-23T14:29:20Z",
                "name" "V_Dev_Traveller_Quote_History",
                "status" "active",
                "created-at" "2022-03-23T14:27:51Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "0d5d1e28-a84b-41ed-84e7-17d4aec8cd35",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0d5d1e28-a84b-41ed-84e7-17d4aec8cd35",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-23T14:31:08Z",
                "name" "V_Dev_Traveller_Quote_Latest",
                "status" "active",
                "created-at" "2022-03-23T14:31:08Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "9362cd3c-e733-4fd1-8394-71daa377c656",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2a00fc73-1682-4b5b-9bd6-b2b2e286be19",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-01-31T11:43:14Z",
                "name" "V_Dev_Fact_Pricing_Source",
                "status" "active",
                "created-at" "2021-07-16T15:15:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [





                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "2c38ee66-a129-47c7-9b21-926aa7f2ce5a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f49799ba-f5aa-4001-aa8e-f35cbff82343",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-17T10:20:14Z",
                "name" "V_Dev_Traveller_AccountInvoice_History",
                "status" "active",
                "created-at" "2021-12-23T13:24:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "10d8b02b-3eeb-4483-beba-febc7a33c9e1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bb6c07cc-45ba-480f-94ed-218d794dd628",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-17T10:20:22Z",
                "name" "V_Dev_Traveller_AccountInvoice_Latest",
                "status" "active",
                "created-at" "2021-12-23T14:15:49Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "6671462a-c276-4ed3-a6b3-5113ce6f9e01",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "5fea8c34-aa0f-4750-8190-89a8f51a21f9",
                "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "hour" nil,
                "updated-at" "2022-03-23T16:58:12Z",
                "name" "PROD.DEV_STAGING.BINGADS_ADGROUPPERFORMANCE_BACKFLL_KLEENED",
                "status" "active",
                "created-at" "2022-03-23T16:56:54Z",
                "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2"
            },
            {
                "master-id" "0ab6b875-bf14-41b1-917d-832cf1e97b96",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "9701ab4b-f5e1-46cb-96db-711503c89e94",
                "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "hour" [
                    2
                ],
                "updated-at" "2022-03-23T17:02:40Z",
                "name" "PROD.DEV_STAGING.BINGADS_ADGROUPPERFORMANCE_YESTERDAY_KLEENED",
                "status" "active",
                "created-at" "2022-03-23T17:02:19Z",
                "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2"
            },
            {
                "master-id" "7dbe0d7e-8433-49ca-80a9-63b573a6219b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "7dbe0d7e-8433-49ca-80a9-63b573a6219b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-04T09:26:04Z",
                "name" "V_Live_Traveller_Enquiry_Raw",
                "status" "active",
                "created-at" "2022-04-04T09:26:04Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "3d02ed2c-7b38-408b-b664-491d4de0ac02",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "3d02ed2c-7b38-408b-b664-491d4de0ac02",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-02-18T13:49:57Z",
                "name" "V_Live_TravelChapter_Data_Brands_Raw",
                "status" "active",
                "created-at" "2022-02-18T13:49:57Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "67f7c79c-8cb5-43be-b9e5-bbd6782670fa",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "67f7c79c-8cb5-43be-b9e5-bbd6782670fa",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-04T10:02:30Z",
                "name" "V_Live_Traveller_ImageDetails_Raw",
                "status" "active",
                "created-at" "2022-04-04T10:02:30Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "dc938a75-b8bd-4034-bf2a-a47e70ccd5fc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "00e6215c-c50f-46e9-bd02-f382fdd1144d",
                "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "hour" [
                    2
                ],
                "updated-at" "2022-03-23T17:08:24Z",
                "name" "PROD.DEV_STAGING.BINGADS_ADGROUPPERFORMANCE_ENTITY",
                "status" "active",
                "created-at" "2022-03-23T17:05:42Z",
                "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 20,
                
                "description" nil,
                "group-id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2"
            },
            {
                "master-id" "5c422595-30f4-4e38-88bd-b8dc45f2d0b9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5c422595-30f4-4e38-88bd-b8dc45f2d0b9",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:10:14Z",
                "name" "V_Live_Traveller_ImageDetails_History",
                "status" "active",
                "created-at" "2022-04-04T10:10:14Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "faf18ab1-556b-4ad8-9729-0c0726963d9b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "faf18ab1-556b-4ad8-9729-0c0726963d9b",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:11:55Z",
                "name" "V_Live_Traveller_ImageDetails_Latest",
                "status" "active",
                "created-at" "2022-04-04T10:11:55Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e4ac1a6f-ccfd-44d2-b4f3-9d2174093ff3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "e4ac1a6f-ccfd-44d2-b4f3-9d2174093ff3",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-04T10:14:24Z",
                "name" "V_Live_Traveller_SupplierImage_Raw",
                "status" "active",
                "created-at" "2022-04-04T10:14:24Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "caebfe01-d69f-44a9-b361-7c825bf0aa27",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8aec4032-f212-4768-bb48-cbc8c3bc3339",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T13:53:17Z",
                "name" "V_Live_TravelChapter_Data_Brands_Latest",
                "status" "active",
                "created-at" "2022-02-18T13:50:47Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "578afeae-4902-4bec-976a-0bd19f8f4478",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "bc821274-ed96-41fa-8e12-160394c5ffb2",
                "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "hour" [
                    2
                ],
                "updated-at" "2022-03-23T17:16:25Z",
                "name" "PROD.DEV_STAGING.BINGADS_ADGROUPPERFORMANCE_DOMAIN",
                "status" "active",
                "created-at" "2022-03-23T17:13:50Z",
                "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 30,
                
                "description" nil,
                "group-id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2"
            },
            {
                "master-id" "9cba1212-34bf-45e6-adc8-dc829d6d3ddc",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9cba1212-34bf-45e6-adc8-dc829d6d3ddc",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-07T09:27:12Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSESSIONSTABLE_UNIONED_KLEENED",
                "status" "active",
                "created-at" "2022-03-07T09:27:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "0b65e15f-35a7-40cc-b707-fc57b23de049",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0b65e15f-35a7-40cc-b707-fc57b23de049",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T13:52:15Z",
                "name" "V_Live_TravelChapter_Data_Brands_History",
                "status" "active",
                "created-at" "2022-02-18T13:52:15Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0a0b6f51-22bd-45b3-8dd3-6ee9b39b0d08",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "0a0b6f51-22bd-45b3-8dd3-6ee9b39b0d08",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-02-18T18:49:24Z",
                "name" "V_Live_TravelChapter_Data_LawfulBasis_Raw",
                "status" "active",
                "created-at" "2022-02-18T18:49:24Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "d6b25db2-bf3a-4b60-a864-0c0278ec4f6d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d6b25db2-bf3a-4b60-a864-0c0278ec4f6d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:54:19Z",
                "name" "V_Live_TravelChapter_Data_OptInPermissions_History",
                "status" "active",
                "created-at" "2022-02-18T18:54:19Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "2d66bdc1-4c91-478d-a138-a8989ef4339e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2d66bdc1-4c91-478d-a138-a8989ef4339e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:50:38Z",
                "name" "V_Live_TravelChapter_Data_LawfulBasis_Latest",
                "status" "active",
                "created-at" "2022-02-18T18:50:38Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "45c10f09-7b46-488b-86b6-0f23776fd110",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "45c10f09-7b46-488b-86b6-0f23776fd110",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:55:31Z",
                "name" "V_Live_TravelChapter_Data_OptInPermissions_Latest",
                "status" "active",
                "created-at" "2022-02-18T18:55:31Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "bfb8e15e-179a-4a0d-93b4-4a850c69da85",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bfb8e15e-179a-4a0d-93b4-4a850c69da85",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:50:00Z",
                "name" "V_Live_TravelChapter_Data_LawfulBasis_History",
                "status" "active",
                "created-at" "2022-02-18T18:50:00Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "1706039c-0bd5-4821-aa31-ca65a9d6d6e1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "1706039c-0bd5-4821-aa31-ca65a9d6d6e1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-02-18T18:52:55Z",
                "name" "V_Live_TravelChapter_Data_OptInPermissions_Raw",
                "status" "active",
                "created-at" "2022-02-18T18:52:55Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "9b7eb417-b926-4d21-b380-647cabb659f2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9b7eb417-b926-4d21-b380-647cabb659f2",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:53:47Z",
                "name" "V_Live_TravelChapter_Data_OptInPermissions_History_Secure",
                "status" "active",
                "created-at" "2022-02-18T18:53:47Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "3c3274d1-8847-4b7b-b182-d79178694ec3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3c3274d1-8847-4b7b-b182-d79178694ec3",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:55:01Z",
                "name" "V_Live_TravelChapter_Data_OptInPermissions_Latest_Secure",
                "status" "active",
                "created-at" "2022-02-18T18:55:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "fca1bc6e-884f-4c49-9729-33c94583205e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "fca1bc6e-884f-4c49-9729-33c94583205e",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-02-18T18:57:10Z",
                "name" "V_Live_Traveller_Client_Raw",
                "status" "active",
                "created-at" "2022-02-18T18:57:10Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "423c0074-0e98-45d9-a124-cccbde4269cb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "423c0074-0e98-45d9-a124-cccbde4269cb",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:58:06Z",
                "name" "V_Live_Traveller_Client_History_Secure",
                "status" "active",
                "created-at" "2022-02-18T18:58:06Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6e04104a-aade-49d0-aa76-a153b227a482",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6e04104a-aade-49d0-aa76-a153b227a482",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:58:48Z",
                "name" "V_Live_Traveller_Client_History",
                "status" "active",
                "created-at" "2022-02-18T18:58:48Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "ae899398-f23f-4640-8b06-b9f73b8c6371",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ae899398-f23f-4640-8b06-b9f73b8c6371",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:59:53Z",
                "name" "V_Live_Traveller_Client_Latest",
                "status" "active",
                "created-at" "2022-02-18T18:59:53Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "609624c0-b3ad-46b0-b37f-6d118cc9e3e1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "609624c0-b3ad-46b0-b37f-6d118cc9e3e1",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-02-18T18:59:26Z",
                "name" "V_Live_Traveller_Client_Latest_Secure",
                "status" "active",
                "created-at" "2022-02-18T18:59:26Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "518ab388-75d6-445f-ac95-e70de10b4531",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "518ab388-75d6-445f-ac95-e70de10b4531",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONVERSATIONS_RAW",
                "status" "active",
                "created-at" "2022-02-23T11:45:53Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "7b8b86d9-dbfe-4cbc-abe0-4ad73652b9e4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7b8b86d9-dbfe-4cbc-abe0-4ad73652b9e4",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-23T11:48:38Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONVERSATIONS_RAW",
                "status" "active",
                "created-at" "2022-02-23T11:48:38Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "8099e3a4-46a8-40e7-9894-bfb552e5107d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b3bbab33-77f5-4538-8211-552dd58198ba",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-23T15:18:53Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T14:05:34Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "98acd74e-8ac8-492c-a0e7-2e8f8195820e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "632d9ef9-b363-445b-a969-a0f9def68688",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-23T15:20:59Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONTACTS_HISTORY",
                "status" "active",
                "created-at" "2022-01-31T15:35:50Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "221e4700-9e66-4f8c-8b28-317ddd825999",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c7a42d5f-b143-4c64-9ea3-a174c9079bad",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-23T15:20:48Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONTACTS_LATEST",
                "status" "active",
                "created-at" "2022-01-31T17:36:58Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "438e0371-5927-428c-b48a-4b8d03203899",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6e18c578-64a9-4358-876f-d8032b28547b",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-02-23T17:04:44Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONVERSATIONS_ENTITY",
                "status" "active",
                "created-at" "2022-02-23T14:30:45Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "4abce69a-6d34-45ac-843c-e51787b767b5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "4abce69a-6d34-45ac-843c-e51787b767b5",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-04T10:31:25Z",
                "name" "V_Live_Traveller_Booking_Raw",
                "status" "active",
                "created-at" "2022-04-04T10:31:25Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "fe46b8e2-5806-407f-9d8a-446b5f71d4f3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "345160c6-29f5-4e1a-b485-3fef150cbfd0",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-30T14:11:06Z",
                "name" "V_Dev_Traveller_Enquiry_History_Secure",
                "status" "active",
                "created-at" "2022-03-30T13:48:28Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "c507c0d0-4ed2-4b9b-aae3-6f842126d8b0",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "af772fdf-db0e-4287-9218-9d069be98a0c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_ADSET_1MONTH_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:53:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "39dfa5a9-0b11-4baa-bf75-aab945833ad5",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "5ef9bdc8-4071-408a-9172-479b1815c731",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "DEV_STAGING.BIGQUERY_GA_DAILYCUSTOMDIMSTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:13:24Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "dff7e36f-62f7-4df3-80af-d62d9d835190",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "78c7ebd5-e0c3-4b3e-9961-2f32ca52ce1e",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-30T14:12:32Z",
                "name" "V_Dev_Traveller_Enquiry_Latest_Secure",
                "status" "active",
                "created-at" "2022-03-30T14:04:08Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "fa20a878-c6c6-4afb-a221-8b8498729fbb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "09f699da-7585-4454-8ee4-a8c95a5f8060",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-30T14:21:09Z",
                "name" "V_Dev_Traveller_Enquiry_History",
                "status" "active",
                "created-at" "2022-03-30T14:20:27Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "3808cd79-b94d-49ff-9924-1deb182b50f0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "547d6f1f-4918-4720-85a6-3d03b7a55ebe",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-30T14:27:07Z",
                "name" "V_Dev_Traveller_Enquiry_Latest",
                "status" "active",
                "created-at" "2022-03-30T14:23:22Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "f288387b-29de-48f1-ad2a-fa456ee289c5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "748578e7-3758-4739-a9ab-692ff922252a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-05T15:30:15Z",
                "name" "V_Live_Traveller_Login_Raw",
                "status" "paused",
                "created-at" "2021-07-26T14:32:16Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "7b3754fe-43ad-4704-a2e1-4d58f9630a6a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "54693f3f-36b4-485f-84a7-9cdce691899c",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-30T14:48:12Z",
                "name" "V_Dev_Traveller_ImageDetails_Raw",
                "status" "active",
                "created-at" "2022-03-30T14:36:00Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "54c0fca3-e2b5-4ee6-af28-80cf8e615c51",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "54c0fca3-e2b5-4ee6-af28-80cf8e615c51",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-03-28T09:01:28Z",
                "name" "V_Live_Traveller_Quote_Raw",
                "status" "active",
                "created-at" "2022-03-28T09:01:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "ad9093a7-0574-4d08-a657-5a7a98ca29c3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2005f851-4629-4c21-9ad1-16ed7a078434",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-07T15:56:25Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY",
                "status" "active",
                "created-at" "2021-12-06T11:33:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "cbc2a21e-209f-4a5c-9b07-6e0c43c40e7c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "cbc2a21e-209f-4a5c-9b07-6e0c43c40e7c",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-28T09:03:23Z",
                "name" "V_Live_Traveller_Quote_History",
                "status" "active",
                "created-at" "2022-03-28T09:03:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "0774e645-e12c-44b4-ba2b-bc9a17251094",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0774e645-e12c-44b4-ba2b-bc9a17251094",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-07T16:03:44Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA",
                "status" "active",
                "created-at" "2022-03-07T16:03:44Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "e3f2b488-7d13-4938-bf98-ce25806c8223",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e3f2b488-7d13-4938-bf98-ce25806c8223",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-03-28T09:05:28Z",
                "name" "V_Live_Traveller_Quote_Latest",
                "status" "active",
                "created-at" "2022-03-28T09:05:28Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "29cc95da-ddec-4a98-ab48-d35d8db030d2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d1c751d2-de3d-4da8-9294-d678b1a0eeca",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-07T16:13:53Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY",
                "status" "active",
                "created-at" "2021-12-06T11:52:54Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93"
            },
            {
                "master-id" "140e5d4d-fbd3-4d29-8f1d-34e1bbc103e0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "41d15051-788f-449e-b1c7-a939eaf00a52",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-30T15:23:15Z",
                "name" "V_Dev_Traveller_ImageDetails_History",
                "status" "active",
                "created-at" "2022-03-30T15:14:26Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b5e72d47-b339-4b95-a266-bd544b1fc2ce",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b5e72d47-b339-4b95-a266-bd544b1fc2ce",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-30T15:28:48Z",
                "name" "V_Dev_Traveller_ImageDetails_Latest",
                "status" "active",
                "created-at" "2022-03-30T15:28:48Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "aa291df7-d0f7-478a-ab71-4c1f3b42513c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "aa291df7-d0f7-478a-ab71-4c1f3b42513c",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-31T09:13:46Z",
                "name" "V_Dev_Traveller_SupplierImage_Raw",
                "status" "active",
                "created-at" "2022-03-31T09:13:46Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "451850a9-cf93-4577-a31e-cdb8249db18b",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "5d207580-4e35-48be-a498-a39adcd77d11",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-31T09:19:46Z",
                "name" "V_Dev_Traveller_SupplierImage_Latest",
                "status" "active",
                "created-at" "2022-03-31T09:19:19Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "789c1e28-35f8-4b3f-97b7-700cf8692a21",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "60ed3b09-642c-4fd1-85e0-9406ee50b043",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:58:14Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "5c16743a-2b55-412c-8a0e-da3179a13c8f",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "1c708ee9-676d-42cc-80c4-60689bb3f056",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSITESEARCHTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2021-11-29T11:54:16Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "9cba3e98-16c9-463e-af8c-63f53aef6ef5",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "055e5789-f3dd-476e-bbe3-07eeb3a2fe99",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY_UNIONED_RAW",
                "status" "active",
                "created-at" "2021-11-30T09:10:42Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "c1edf710-6d2f-4a46-9fbf-1a763bed5050",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "c1edf710-6d2f-4a46-9fbf-1a763bed5050",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-16T14:59:11Z",
                "name" "V_Dev_Traveller_Voucher_Raw",
                "status" "active",
                "created-at" "2022-03-16T14:59:11Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "b848e85e-a263-496f-9c12-41fccacf8812",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "fa5efa42-5ec6-4d68-86fd-9edfaf4daca1",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-16T15:27:43Z",
                "name" "V_Dev_Traveller_Voucher_History",
                "status" "active",
                "created-at" "2022-03-16T15:26:29Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "da1e7aa8-c428-45ab-ae04-995bb7f1bd93",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3dcbaca4-bf33-45f3-afe4-c587bc660150",
                "updated-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "hour" nil,
                "updated-at" "2022-03-30T13:31:22Z",
                "name" "V_Dev_Traveller_Enquiry_Raw",
                "status" "active",
                "created-at" "2022-03-30T13:29:34Z",
                "created-by" "020edf5e-1895-446b-9e85-7da8133a86af",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "7b6ee597-ca07-4cf6-bcd9-8eb3152e20c8",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "72fdd353-8237-4a91-8cba-2bc4cf444b09",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-03-18T10:22:17Z",
                "name" "PROD.DEV_STAGING.GOOGLEADSCAMPAIGNDATA_UNIONED",
                "status" "active",
                "created-at" "2021-12-10T18:04:46Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "37086ea3-13b8-4e80-a170-7cf626b14fb6",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "9b12e690-0470-491f-a3df-ecf97990de43",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGN_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:44:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "203955f2-ea0d-4e93-8c23-99a081ca38c7",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "aa44df12-4b08-4b38-a44b-5a7da8fe6063",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-01-31T11:01:24Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "9f87e832-922a-4ee8-8324-030f52524450",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9f87e832-922a-4ee8-8324-030f52524450",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "hour" nil,
                "updated-at" "2022-03-18T14:25:10Z",
                "name" "V_Dev_Traveller_CleaningCharges_History",
                "status" "active",
                "created-at" "2022-03-18T14:25:10Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "80264c11-5ad9-471d-80d0-cd8199a9c7fc",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6fc74b34-8e0c-4a8a-8294-8aeb12504852",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "hour" nil,
                "updated-at" "2022-03-18T14:32:05Z",
                "name" "V_Dev_Traveller_CleaningCharges_Raw",
                "status" "active",
                "created-at" "2022-03-18T14:02:39Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "e31fd141-9db3-4225-a8ed-ea51e1914dc6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e31fd141-9db3-4225-a8ed-ea51e1914dc6",
                "updated-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "hour" nil,
                "updated-at" "2022-03-31T09:17:49Z",
                "name" "V_Dev_Traveller_SupplierImage_History",
                "status" "active",
                "created-at" "2022-03-31T09:17:49Z",
                "created-by" "3cc610de-90c8-4940-b07d-8397ece1e793",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "da2d4ab8-e1e7-4f61-89a2-3e76a5974c37",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "da2d4ab8-e1e7-4f61-89a2-3e76a5974c37",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T09:54:14Z",
                "name" "V_Live_Traveller_Enquiry_Latest",
                "status" "active",
                "created-at" "2022-04-04T09:54:14Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "41cce0a9-b668-4233-84e9-593945d1591a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "41cce0a9-b668-4233-84e9-593945d1591a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T09:28:43Z",
                "name" "V_Live_Traveller_Enquiry_History_Secure",
                "status" "active",
                "created-at" "2022-04-04T09:28:43Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "653be636-79dc-4987-ba6b-77f2a2631d2f",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "653be636-79dc-4987-ba6b-77f2a2631d2f",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T09:37:52Z",
                "name" "V_Live_Traveller_Enquiry_History",
                "status" "active",
                "created-at" "2022-04-04T09:37:52Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "6faa5235-a4b6-4cb3-a118-b8ae38016be9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "6faa5235-a4b6-4cb3-a118-b8ae38016be9",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T09:53:19Z",
                "name" "V_Live_Traveller_Enquiry_Latest_Secure",
                "status" "active",
                "created-at" "2022-04-04T09:53:19Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "1acc4f71-ece8-4f2c-b385-b5398eb0e114",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1acc4f71-ece8-4f2c-b385-b5398eb0e114",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:15:23Z",
                "name" "V_Live_Traveller_SupplierImage_History",
                "status" "active",
                "created-at" "2022-04-04T10:15:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "e3dc57d6-e83f-4dfb-89c2-a115464cef56",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e3dc57d6-e83f-4dfb-89c2-a115464cef56",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:39:21Z",
                "name" "V_Live_Traveller_Booking_Latest",
                "status" "active",
                "created-at" "2022-04-04T10:39:21Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "217e2cb3-a603-473f-b176-65221e28b64d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "217e2cb3-a603-473f-b176-65221e28b64d",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:33:14Z",
                "name" "V_Live_Traveller_Booking_History",
                "status" "active",
                "created-at" "2022-04-04T10:33:14Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "57fa36ae-bcf4-45dc-b9b7-12b233d97b73",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "57fa36ae-bcf4-45dc-b9b7-12b233d97b73",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:39:20Z",
                "name" "V_Live_Traveller_Booking_Latest",
                "status" "active",
                "created-at" "2022-04-04T10:39:20Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "58bd8ccb-d2d8-4483-ae23-198c3e6511a0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "58bd8ccb-d2d8-4483-ae23-198c3e6511a0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" [
                    4
                ],
                "updated-at" "2022-04-04T10:42:23Z",
                "name" "V_Live_Traveller_Itinerary_Raw",
                "status" "active",
                "created-at" "2022-04-04T10:42:23Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 0,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "b413c61a-b4b8-48a2-b870-4f37630d7fd0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b413c61a-b4b8-48a2-b870-4f37630d7fd0",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:44:01Z",
                "name" "V_Live_Traveller_Itinerary_History",
                "status" "active",
                "created-at" "2022-04-04T10:44:01Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "8468b2d0-8e94-430b-ab1c-63f5c9d2436a",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8468b2d0-8e94-430b-ab1c-63f5c9d2436a",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-04T10:48:47Z",
                "name" "V_Live_Traveller_Itinerary_Latest",
                "status" "active",
                "created-at" "2022-04-04T10:48:47Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ba18f62c-0297-4aa3-8fde-f01ad890a672"
            },
            {
                "master-id" "9ca95f21-f030-472f-b99f-845399dae042",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9ca95f21-f030-472f-b99f-845399dae042",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:51:04Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:51:04Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "23fc0f04-b199-4749-86db-8aa05bf62e12",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "23fc0f04-b199-4749-86db-8aa05bf62e12",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:11:49Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_ADSET_1MONTH_RAW",
                "status" "active",
                "created-at" "2022-04-04T15:11:49Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "b9079086-b8a3-4739-a557-31d9972d6c28",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b9079086-b8a3-4739-a557-31d9972d6c28",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:12:11Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_CAMPAIGN_1MONTH_RAW",
                "status" "active",
                "created-at" "2022-04-04T15:12:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "b9bb953e-2354-4b1c-8984-5f0ea0864241",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "de3772cd-7985-4d22-80c3-2725dba70d17",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:12:46Z",
                "name" "PROD.DEV_STAGING.FB_ADS_ENTITY",
                "status" "active",
                "created-at" "2021-12-06T19:11:20Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "2b860659-aa73-4a73-84ac-748579fa33e8",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2b860659-aa73-4a73-84ac-748579fa33e8",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:12:30Z",
                "name" "PROD.DEV_STAGING.FB_ADS_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:12:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "e6894ee6-9711-423e-8861-5637151b4af5",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e6894ee6-9711-423e-8861-5637151b4af5",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:26:15Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_AGENTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:26:15Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "2d55d6f4-5827-4d10-84f4-b522054056ef",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "2d55d6f4-5827-4d10-84f4-b522054056ef",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:28:58Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONTACTS_LATEST",
                "status" "active",
                "created-at" "2022-04-04T15:28:58Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "a8cb1e80-2df9-4073-8a1e-8c3a1d9e3ad6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a8cb1e80-2df9-4073-8a1e-8c3a1d9e3ad6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:24:02Z",
                "name" "PROD.DEV_STAGING.FB_ADS_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:24:02Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "e96ebd3c-70fa-46c2-b0a0-f898626f360d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "e96ebd3c-70fa-46c2-b0a0-f898626f360d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:24:24Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:24:24Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "bdd16fd2-82fa-4deb-b3c8-067e344e3d6b",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bdd16fd2-82fa-4deb-b3c8-067e344e3d6b",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:24:50Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_ACTIONTYPE_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:24:50Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "dcd7acc8-de83-4343-b65d-e11dae93f88c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "dcd7acc8-de83-4343-b65d-e11dae93f88c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:25:12Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:25:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "d6a7cac7-e67b-4e13-a6ad-de85ed1c6d57",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d6a7cac7-e67b-4e13-a6ad-de85ed1c6d57",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:25:48Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_AGENTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:25:48Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "60661df6-fa33-4b08-8dee-cb28e649be04",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "60661df6-fa33-4b08-8dee-cb28e649be04",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:27:39Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONTACTS_HISTORY",
                "status" "active",
                "created-at" "2022-04-04T15:27:39Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4c631de5-5854-49d7-975e-2d1d764f4deb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4c631de5-5854-49d7-975e-2d1d764f4deb",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:51:36Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:51:36Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "7f6dd9b0-1f85-4486-a639-b48fa102b476",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7f6dd9b0-1f85-4486-a639-b48fa102b476",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:29:23Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONVERSATIONS_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:29:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "11c3de9c-f6b9-4ace-98ce-97ca642e35e6",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "11c3de9c-f6b9-4ace-98ce-97ca642e35e6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:41:13Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_CONVERSATIONS_RAW",
                "status" "active",
                "created-at" "2022-04-04T15:41:13Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "646985e9-72a8-455a-bae7-d6ab69c2e9e0",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "646985e9-72a8-455a-bae7-d6ab69c2e9e0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:42:27Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_ATTACHMENTS_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:42:27Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4b9c4518-b531-41ec-9888-69659ebc286d",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4b9c4518-b531-41ec-9888-69659ebc286d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:43:32Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_ENTITY",
                "status" "active",
                "created-at" "2022-04-04T15:43:32Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "bb28419f-ee08-4818-82ed-6a9be756ec09",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "bb28419f-ee08-4818-82ed-6a9be756ec09",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T15:56:37Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSESSIONSTABLE_UNIONED_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T15:56:37Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "26d87dc3-13d5-408f-927f-40c3d0fa3214",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "bca7dbf3-ea1a-45cd-8097-c8b030019cac",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:23:53Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSITESEARCHPLUSCUSTOMDIMSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:22:48Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "217b5eaf-5be6-43bc-afde-feffc8f41feb",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "0ac863ed-82c6-499b-843c-3d8394459531",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:30:28Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCROSSDEVICECONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:30:20Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ff947db6-3e66-46e0-b6c2-520bd13df3e7",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "781fde3f-8de5-4d64-b365-c92ee2b57d00",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:22:01Z",
                "name" "PROD.DEV_STAGING.GA_DAILYHITSPAGEVIEWSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2022-04-04T15:55:22Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "8b45395d-1052-44b5-aeb8-6c0b8be7890c",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "a6d53fc3-45e5-48a6-8833-31d4588346a6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:22:21Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSESSIONSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:21:34Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4fed3cfe-02e3-4897-a468-282a1c255585",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "623a3720-c0fd-49fc-ae13-c277323454fa",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:24:56Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY_UNIONED_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:24:44Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "0624572a-f38b-4898-8377-d9141647d23e",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "570fb583-15ef-4f5e-9ffc-f0590041ac25",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:31:03Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCROSSDEVICESTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:30:50Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "2cd7ba04-660f-4ce3-981d-339351f5d748",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "b0f3558c-4d5a-4f0e-b2d3-d9b091fa506e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:24:10Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSITESEARCHTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:23:32Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "f3e42d42-ee03-44dd-8151-322437dcc5c6",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "52ae67d4-1897-419f-8f54-2708f45c6c4d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:26:03Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTBASICSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:25:54Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "7d47ec26-80d2-42d2-b479-abb42f10e025",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "7310f0ef-7222-497b-86ef-671be02187ff",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:29:43Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:29:34Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "8476a0fa-6653-4c56-92c5-36b6171fa957",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8476a0fa-6653-4c56-92c5-36b6171fa957",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:18:05Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY",
                "status" "active",
                "created-at" "2022-04-04T17:18:05Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "60ad6393-e007-49e2-9791-be7312d19fcb",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "8c603b21-5058-4c56-811d-a29b8b956a8d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:26:48Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:26:41Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "15f4030c-0ac6-4fd6-beef-0e81107073d2",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "fda7900d-ea7c-46f0-a991-35bf82fdba03",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:27:19Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTNONCLICKSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:27:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "9dafabd0-a114-4cdd-a630-9d60c859cfea",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "287cd629-af61-4475-8935-6b49aefc5a54",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:28:16Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:28:10Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "1a6ef814-0852-4259-86d6-21cfca38b25c",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "d939528d-d6a2-44e0-bcd4-9a9e46e350e1",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:28:56Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPBASICSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:28:45Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "c717b6e5-2cc6-4be1-bca6-cd21febc85b9",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "03bd041e-4e7b-485a-9e13-a05394d26fa4",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:31:50Z",
                "name" "PROD.DEV_STAGING.GOOGLEADSCAMPAIGNDATA_UNIONED",
                "status" "active",
                "created-at" "2022-04-04T16:31:42Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "c67f3865-dee5-477e-99a7-96387b3bed4a",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "7ec5ed99-f927-4cc4-9c43-c1e197570dd9",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:33:37Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGN_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:33:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "d940a3e1-4bf6-4fb9-a5b9-f77c50710e26",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "d940a3e1-4bf6-4fb9-a5b9-f77c50710e26",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:39:46Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T16:39:46Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "cd53b2b4-9a46-4d8b-9367-0433b6d70cda",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "c1018151-3d2d-4822-864f-05f317945850",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:34:29Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:34:20Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "28f8ba1c-04bd-4f55-a51d-947489d16250",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "28f8ba1c-04bd-4f55-a51d-947489d16250",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:36:48Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T16:36:48Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "3680e0bc-ecdf-4614-9183-4e69860051db",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "3680e0bc-ecdf-4614-9183-4e69860051db",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:37:31Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T16:37:31Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "194825e2-6d00-4d68-9af1-fa92aaaf77ce",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "9ae5a7bc-e374-4fc1-9db0-f8c2ca9765cf",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:35:13Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CLICKSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:35:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ece7a664-634c-47e7-8b1b-580f80b4a7e1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ece7a664-634c-47e7-8b1b-580f80b4a7e1",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:40:07Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONVERSATIONS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:40:07Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "99f70155-963e-47fb-b094-b79242949442",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "99f70155-963e-47fb-b094-b79242949442",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:41:11Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T16:41:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "eecdfc6b-cd96-428a-bd31-df4b1c690c4c",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "79eb94ac-434a-4e30-b8b4-7e422e12f20b",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:36:19Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_PAIDORGANICSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:36:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "795cc6b4-a93a-42d8-b53a-7dcc240b0121",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "795cc6b4-a93a-42d8-b53a-7dcc240b0121",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:40:30Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T16:40:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "2e529a74-354f-4783-89a5-ef9c01aa3c1f",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "964a215c-b705-4905-bcbf-87bc11ee9d90",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:38:39Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:38:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "1dbef14f-2034-45ca-811a-21567f759566",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "f3a7e9fa-3e4a-4251-a31d-271529f38bf5",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:39:14Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:39:02Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "5440ebd0-a44e-487d-a61e-a493d132305d",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "6a519100-db10-40cb-9c88-2984f76ae30d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T16:40:57Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-04-04T16:40:49Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4bf30d08-2eb5-42ac-a300-84d1e4f84552",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4bf30d08-2eb5-42ac-a300-84d1e4f84552",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:14:57Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-04-04T17:14:57Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "1fa674af-c0e6-4259-a4e2-4efd4d87d047",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "8a23e146-443d-4239-b3b1-7a7f5ace3eb0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:09:40Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCOOKIESTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:09:32Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "9e8b057c-59f5-4c86-82d0-f9f458e1bc5c",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "9e8b057c-59f5-4c86-82d0-f9f458e1bc5c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:16:53Z",
                "name" "PROD.DEV_STAGING.FB_CAMPAIGN_DOMAIN",
                "status" "active",
                "created-at" "2022-04-04T17:16:53Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "b7e80e6b-c29a-433d-a46f-07fd8783da3f",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "0a680852-7643-4b40-b829-abc7d6157635",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:08:11Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNBASICSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:08:02Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "0254ac03-dca1-43f0-9657-19f43c7dc967",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "e9353466-6e1b-446a-a485-95b53037be44",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:10:31Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCROSSDEVICECONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:10:24Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ee88bc52-7791-47ae-9081-a3646f6b12a1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ee88bc52-7791-47ae-9081-a3646f6b12a1",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:16:30Z",
                "name" "PROD.DEV_STAGING.FB_ADSET_DOMAIN",
                "status" "active",
                "created-at" "2022-04-04T17:16:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "85cb7f9c-3165-42ef-981f-a30c9860ac4c",
                "ignore-parser" true,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" nil,
                "id" "63fbd5a4-4f83-49cf-bda5-c119b8633a55",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:11:20Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCROSSDEVICESTATS_RAW",
                "status" "active",
                "created-at" "2022-04-04T17:11:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "371ef15d-e16a-4f8c-b9de-4e15c4484511",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "371ef15d-e16a-4f8c-b9de-4e15c4484511",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:17:28Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_DOMAIN",
                "status" "active",
                "created-at" "2022-04-04T17:17:28Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [




                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "952b7a18-b42a-49a3-be2e-6bc88e1af2b3",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "952b7a18-b42a-49a3-be2e-6bc88e1af2b3",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:22:11Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH",
                "status" "active",
                "created-at" "2022-04-04T17:22:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "4522e519-a3cb-490b-b6c3-e7a5def68aec",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "4522e519-a3cb-490b-b6c3-e7a5def68aec",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:24:33Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH_2YA",
                "status" "active",
                "created-at" "2022-04-04T17:24:33Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "a81b49f3-3f72-4447-8114-1a65cbb2a290",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "a81b49f3-3f72-4447-8114-1a65cbb2a290",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:16:04Z",
                "name" "PROD.DEV_STAGING.FB_AD_DOMAIN",
                "status" "active",
                "created-at" "2022-04-04T17:16:04Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "f303c58c-ed57-4b0e-bb26-68ca4f685fd2",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f303c58c-ed57-4b0e-bb26-68ca4f685fd2",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:18:18Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_2YA",
                "status" "active",
                "created-at" "2022-04-04T17:18:18Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "92c7ce81-7978-475d-82a6-da1299005c63",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "92c7ce81-7978-475d-82a6-da1299005c63",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:18:53Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_3YA",
                "status" "active",
                "created-at" "2022-04-04T17:18:53Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "7bec10d6-b4d1-422b-a38b-91aaf165df40",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7bec10d6-b4d1-422b-a38b-91aaf165df40",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:19:30Z",
                "name" "PROD.DEV_STAGING.GA_RAGADATA_DAILY_YOY",
                "status" "active",
                "created-at" "2022-04-04T17:19:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "95f78b9d-f5d1-43b3-bda0-ceb7f5a8d40d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "95f78b9d-f5d1-43b3-bda0-ceb7f5a8d40d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:21:19Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY",
                "status" "active",
                "created-at" "2022-04-04T17:21:19Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "0f3c71f3-ff1d-4ff5-a008-11dbbe9d75cb",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0f3c71f3-ff1d-4ff5-a008-11dbbe9d75cb",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:20:13Z",
                "name" "PROD.DEV_STAGING.GA_RAGA_MONTHLY",
                "status" "active",
                "created-at" "2022-04-04T17:20:13Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ff0675db-c003-444f-8d04-b71d86070b03",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ff0675db-c003-444f-8d04-b71d86070b03",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:21:40Z",
                "name" "PROD.DEV_STAGING.GA_SEARCHIMP_PRODUCTCATEGORY_YOY",
                "status" "active",
                "created-at" "2022-04-04T17:21:40Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "7a380cd5-ba65-421e-9994-41dbaad33d54",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "7a380cd5-ba65-421e-9994-41dbaad33d54",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:26:03Z",
                "name" "PROD.DEV_STAGING.GA_SITESEARCH_YOY",
                "status" "active",
                "created-at" "2022-04-04T17:26:03Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "8d85ead7-d02b-4de8-9151-d6ffe8601156",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "8d85ead7-d02b-4de8-9151-d6ffe8601156",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:26:26Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA",
                "status" "active",
                "created-at" "2022-04-04T17:26:26Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "f8ed79e8-eeda-4bc1-a9ff-bd9bbf2bab2d",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "f8ed79e8-eeda-4bc1-a9ff-bd9bbf2bab2d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:27:23Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS2YA",
                "status" "active",
                "created-at" "2022-04-04T17:27:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "be8e9bd2-bb7b-4bc6-ac0c-b66a4a50de84",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "be8e9bd2-bb7b-4bc6-ac0c-b66a4a50de84",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:26:46Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS",
                "status" "active",
                "created-at" "2022-04-04T17:26:46Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ce72a32e-688a-4c73-98c3-0c23d4a5bf1e",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ce72a32e-688a-4c73-98c3-0c23d4a5bf1e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:28:38Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYSYOY",
                "status" "active",
                "created-at" "2022-04-04T17:28:38Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "ff0eb33b-7aff-4cd9-9a3a-9cbcb2416684",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "ff0eb33b-7aff-4cd9-9a3a-9cbcb2416684",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:28:12Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_LAST7DAYS3YA",
                "status" "active",
                "created-at" "2022-04-04T17:28:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "016fc7d8-dfbd-45bd-a830-5437d54f25f4",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "016fc7d8-dfbd-45bd-a830-5437d54f25f4",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-04T17:29:23Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNDATA_MONTHLY",
                "status" "active",
                "created-at" "2022-04-04T17:29:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [



                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "54b1e7b5-acb2-4834-82c3-58a51a80a337"
            },
            {
                "master-id" "1f3c305d-c9c4-42d9-b0ce-94f8d364709e",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "fe5dea41-d230-46b3-ba97-c41e9ddc6a5e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCROSSDEVICESTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:26:52Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "1d456dca-d5c4-4c59-a974-13cf0f47c830",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "b875c9e7-1fcc-4160-a5e4-cd22cf565486",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "hour" nil,
                "updated-at" "2022-04-05T09:09:50Z",
                "name" "V_Dev_Traveller_Login_Latest",
                "status" "active",
                "created-at" "2021-06-18T08:52:34Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "537f52b1-64bc-4bee-aa17-8fabc862da51"
            },
            {
                "master-id" "19ec7580-088d-4f0d-9fef-bd150a954a2e",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "19ec7580-088d-4f0d-9fef-bd150a954a2e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.BIGQUERY_GA_DAILYSITESEARCHPLUSCUSTOMDIMSTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:22:08Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "40bb7e1b-6203-4088-a3e7-d9750019b917",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "40bb7e1b-6203-4088-a3e7-d9750019b917",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.BIGQUERY_GA_DAILYSESSIONSTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:18:17Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "f0cc994b-50ea-47ef-944f-9f87bf96f250",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "f0cc994b-50ea-47ef-944f-9f87bf96f250",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.BIGQUERY_GA_DAILYSITESEARCHTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:23:22Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "ebfd6469-c7b4-461a-b506-cb02e65a1d53",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "63b536ff-023c-4fc8-a724-4510af388472",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "DEV_STAGING.BIGQUERY_GA_DAILYEECTABLE_HC_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:15:09Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "cacde1ce-0387-4302-9200-057f8d00f8a3",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "43c91076-75d3-4ee2-a3ad-bef01d268c3a",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FACEBOOK_AD_1MONTH_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:50:44Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "8db6565e-1673-4833-a9cb-6d69d91116f1",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "384936ed-7c29-449b-ac5e-c1c21431cf7e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:00:48Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "e1fe6010-c4a0-44d7-b74b-6fe84e1ab008",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "9405ade2-1f0a-43d9-be15-a1cf628879f3",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_RAW",
                "status" "active",
                "created-at" "2022-01-18T09:45:42Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "30ac772e-e3a4-42b9-9767-afe6323b4298",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "959dfc85-e4e1-4d16-95ee-6333f6aeb610",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-05T10:46:51Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T17:56:03Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "66fe50cd-e902-4067-b884-be7c9a787320",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "0469cf97-acdb-46c5-a336-3087475c1eaa",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-05T10:46:51Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T18:09:55Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "69ad8f8e-b394-4d70-9e3c-b24805391e80",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "1d79c468-7d70-4871-8346-4d03fe9cb5e6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-05T10:46:51Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-03-11T11:11:31Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "aa29628c-f6d0-49af-a26a-f96e2983a096",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "339611d9-a1b2-4216-8ecf-36a6b65535f6",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-05T10:46:51Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_AGENTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T11:48:57Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "c43c83c1-a266-45af-927f-0a4281c2e9b9",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" nil,
                "id" "21bf7919-381b-4e41-bb9f-0fca7c02bcf1",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" nil,
                "updated-at" "2022-04-05T10:46:51Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_AGENTS_LATEST_KLEENED",
                "status" "active",
                "created-at" "2022-01-31T11:33:23Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" nil,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "7d121106-fec0-49ad-a71b-a935d625c366",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "8ce8216d-6401-418e-8846-52859d83c62d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCOOKIESTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:36:46Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "569fdeca-8003-46f0-87a8-523837671490",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "1b0c4340-89a2-4e39-9906-007fe538b15c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUP_RAW",
                "status" "active",
                "created-at" "2021-11-11T18:11:01Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "3167533f-b270-47c5-842b-318e5235f26e",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "46861241-f78c-47d5-bc2d-99f2f56dc4c0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CLICKSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:54:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "3f5f1217-39f6-45d6-ad1f-abb1af6587aa",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "2936d665-0e9c-49f7-9149-03eec77a3289",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_PAIDORGANICSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:53:33Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "c3e59a91-c412-4342-85a5-3b9b9cd2f670",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "5b2bd781-15aa-4543-8f2b-0cb1994ac798",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_HISTORY_KLEENED",
                "status" "active",
                "created-at" "2022-02-01T14:03:58Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [


                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "32d6138d-22aa-495a-b2d3-a4c8d298b290",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "32d6138d-22aa-495a-b2d3-a4c8d298b290",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_TICKETS_ATTACHMENTS_KLEENED",
                "status" "active",
                "created-at" "2022-01-18T11:56:11Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "3e8d9be8-bef2-42a9-8abf-9b682f539af0",
                "ignore-parser" false,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [

                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "3e8d9be8-bef2-42a9-8abf-9b682f539af0",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.FRESHDESK_AGENTS_RAW",
                "status" "active",
                "created-at" "2022-01-18T12:03:21Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "4d0b4ef9-9ab4-4672-81d1-8398faed581a",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "0f6b3e67-5da2-4dac-b5b1-0421a838b477",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSITESEARCHPLUSCUSTOMDIMSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2021-12-01T13:00:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "4f859041-7085-4417-9e42-373b687fa929",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "6bfb27b4-317a-4ee9-95bf-fe7d8e6969c7",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GA_DAILYHITSPAGEVIEWSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2021-11-28T19:49:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "36b03418-1508-4eff-8b5f-7a64281112d7",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "91515e18-894e-4805-a6dc-bc9cfae00e5c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GA_DAILYSESSIONSTABLE_UNIONED_RAW",
                "status" "active",
                "created-at" "2021-11-23T13:39:25Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "c38a78c7-8257-4590-ae05-747ff9e6ecf7",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "6fe11076-af1e-430b-8f88-c1b3a022b3a5",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCROSSDEVICECONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:42:17Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "1ea0f3db-00be-406f-8f32-003788f6414d",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "6e560c69-7f12-464a-a573-b6e4d4de817a",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTBASICSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:30:13Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "83f476f3-edef-4f2a-b65d-e1888ef31672",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "2a179231-beae-4246-aef5-da48b3ade853",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:33:00Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "10bf5f83-3cb4-4da7-956a-e0535d22d1d0",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "5e43c795-6b1e-4218-8a30-1ec342df5586",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTNONCLICKSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:34:00Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "255773c5-2b44-4c72-9af9-62a1aa16b911",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "79da43d2-ecf5-4f70-81bf-e23430bcb61c",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ACCOUNTSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:35:18Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "e23230f4-e3e1-49a6-965e-d2408f8915da",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "0bdee5db-c569-4fa2-9cf1-64716699cc0f",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPBASICSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:57:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "c53297b4-2949-4ba1-b8de-1f6325896ee7",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "ab21984a-77c8-42dd-8e65-1e29f80ed000",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCROSSDEVICESTATS_RAW",
                "status" "active",
                "created-at" "2021-11-11T10:35:14Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "6ee9ed21-c93e-4b7c-a10d-196e97b0026a",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "23877e44-5ef2-4b82-9aa0-5b259302b166",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:55:56Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "76aeeb8b-a381-4134-927d-3758d4378e7e",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "007e8ab7-6a53-4caa-b15d-12f6735d9d29",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_ADGROUPCROSSDEVICECONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T15:59:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "08f1cbda-daef-47c0-9b2e-3a79672ac30a",
                "ignore-parser" true,
                
                "output-tables" [

                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "3da0ee7d-2d15-40c8-b43e-ccca4489320d",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNBASICSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T17:36:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "570f293b-27b9-4984-944b-1da6fa4b6551",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "53d5922d-9cd9-413b-8f68-6ade5ad0d6d3",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING.GOOGLEADS_CAMPAIGNCONVERSIONSTATS_RAW",
                "status" "active",
                "created-at" "2021-11-10T16:23:06Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "1def0f16-7d6f-4123-9b6a-6f0e7178c4cd",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "4e4847b5-b877-4c43-9bfc-064d58a52ea9",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_TICKETS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-01-28T17:19:13Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            },
            {
                "master-id" "05887d08-70cb-497a-86ea-e110cf3059ae",
                "ignore-parser" false,
                
                "output-tables" [


                ],
                "is-full" false,
                "statements" [


                ],
                "tags" [],
                "dow" [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ],
                "id" "2f0ec071-3907-4a74-88c0-deffb4e977ba",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "hour" [
                    8
                ],
                "updated-at" "2022-04-05T10:47:04Z",
                "name" "PROD.DEV_STAGING_SECURE.FRESHDESK_CONTACTS_HISTORY_RAW",
                "status" "active",
                "created-at" "2022-01-28T17:32:13Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "is-temp" false,
                "input-tables" [

                ],
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "minute" 15,
                
                "description" nil,
                "group-id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e"
            }
        ],
        "pagination" {
            "items-per-page" 999999,
            "page" 0,
            "total-pages" 1
        }
    },
    "parent-groups" [
        {
            "id" "39471ce0-d96b-4359-8486-07f091ae649c",
            "updated-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
            "updated-at" "2021-05-26T12:35:11Z",
            "bulk-scheduled" false,
            "name" "Acquisition Date",
            "created-at" "2021-05-26T12:35:11Z",
            "created-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "58c7aef3-f472-411d-a179-8d306def0b2d",
            "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
            "updated-at" "2021-05-07T09:18:55Z",
            "bulk-scheduled" false,
            "name" "FeaturesTest",
            "created-at" "2021-05-07T09:18:55Z",
            "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "98665e48-3297-4f9e-bb89-974c2d442c1e",
            "updated-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
            "updated-at" "2021-05-28T08:49:25Z",
            "bulk-scheduled" false,
            "name" "test_notifications_group",
            "created-at" "2021-05-28T08:49:25Z",
            "created-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" "put here for POC to test notifications"
        },
        {
            "id" "537f52b1-64bc-4bee-aa17-8fabc862da51",
            "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
            "updated-at" "2021-12-01T10:59:54Z",
            "bulk-scheduled" false,
            "name" "Dev_Warehouse",
            "created-at" "2021-06-17T08:59:24Z",
            "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "ba18f62c-0297-4aa3-8fde-f01ad890a672",
            "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
            "updated-at" "2021-09-27T12:25:31Z",
            "bulk-scheduled" true,
            "name" "Live_Warehouse",
            "created-at" "2021-07-26T12:15:19Z",
            "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" "Live warehouse."
        },
        {
            "id" "8aa482f9-50e5-4eb3-b80e-f3a27b9abf28",
            "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "updated-at" "2021-10-26T15:00:12Z",
            "bulk-scheduled" false,
            "name" "TransformsTest",
            "created-at" "2021-10-26T15:00:12Z",
            "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2",
            "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
            "updated-at" "2022-03-23T16:56:33Z",
            "bulk-scheduled" false,
            "name" "Bing Ads",
            "created-at" "2022-03-23T16:56:33Z",
            "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "54b1e7b5-acb2-4834-82c3-58a51a80a337",
            "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "updated-at" "2022-04-04T15:07:39Z",
            "bulk-scheduled" false,
            "name" "Live_Analytics",
            "created-at" "2022-04-04T15:07:39Z",
            "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e",
            "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "updated-at" "2022-04-05T10:47:04Z",
            "bulk-scheduled" true,
            "name" "StagingTransforms",
            "created-at" "2021-11-10T14:16:22Z",
            "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        },
        {
            "id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93",
            "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "updated-at" "2022-03-15T09:09:45Z",
            "bulk-scheduled" true,
            "name" "ReportingTransforms",
            "created-at" "2021-11-15T13:29:30Z",
            "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
            "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
            "description" nil
        }
    ],
    "groups" {
        "data" [
            {
                "id" "39471ce0-d96b-4359-8486-07f091ae649c",
                "updated-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "updated-at" "2021-05-26T12:35:11Z",
                "bulk-scheduled" false,
                "name" "Acquisition Date",
                "created-at" "2021-05-26T12:35:11Z",
                "created-by" "754bfa12-1309-4a5d-8859-e6ec3c6ad626",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "5f48a530-33f1-41a7-a1a2-a3a9b94f85a9",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "updated-at" "2021-05-06T10:21:12Z",
                "bulk-scheduled" false,
                "name" "BookingCSVTest",
                "created-at" "2021-05-06T10:21:12Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "58c7aef3-f472-411d-a179-8d306def0b2d",
                "updated-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "updated-at" "2021-05-07T09:18:55Z",
                "bulk-scheduled" false,
                "name" "FeaturesTest",
                "created-at" "2021-05-07T09:18:55Z",
                "created-by" "3bcc707b-0fbe-4142-aac6-77c37db5240b",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "98665e48-3297-4f9e-bb89-974c2d442c1e",
                "updated-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
                "updated-at" "2021-05-28T08:49:25Z",
                "bulk-scheduled" false,
                "name" "test_notifications_group",
                "created-at" "2021-05-28T08:49:25Z",
                "created-by" "58872b57-b3d2-4dc8-8078-1fffd2dd5e74",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" "put here for POC to test notifications"
            },
            {
                "id" "537f52b1-64bc-4bee-aa17-8fabc862da51",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "updated-at" "2021-12-01T10:59:54Z",
                "bulk-scheduled" false,
                "name" "Dev_Warehouse",
                "created-at" "2021-06-17T08:59:24Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "ba18f62c-0297-4aa3-8fde-f01ad890a672",
                "updated-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "updated-at" "2021-09-27T12:25:31Z",
                "bulk-scheduled" true,
                "name" "Live_Warehouse",
                "created-at" "2021-07-26T12:15:19Z",
                "created-by" "de0e5edb-98a7-45ca-ad26-d4aa97e4ebb8",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" "Live warehouse."
            },
            {
                "id" "8aa482f9-50e5-4eb3-b80e-f3a27b9abf28",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "updated-at" "2021-10-26T15:00:12Z",
                "bulk-scheduled" false,
                "name" "TransformsTest",
                "created-at" "2021-10-26T15:00:12Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "afb9e5c0-2501-40ac-975d-5de3dd09bfb2",
                "updated-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "updated-at" "2022-03-23T16:56:33Z",
                "bulk-scheduled" false,
                "name" "Bing Ads",
                "created-at" "2022-03-23T16:56:33Z",
                "created-by" "3bb4de7a-4165-4e11-bdd0-523522afd540",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "54b1e7b5-acb2-4834-82c3-58a51a80a337",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "updated-at" "2022-04-04T15:07:39Z",
                "bulk-scheduled" false,
                "name" "Live_Analytics",
                "created-at" "2022-04-04T15:07:39Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "ab3ec024-bfd8-4146-b5db-d4b393cbf44e",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "updated-at" "2022-04-05T10:47:04Z",
                "bulk-scheduled" true,
                "name" "StagingTransforms",
                "created-at" "2021-11-10T14:16:22Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            },
            {
                "id" "5bb21d08-fc3e-48fe-afed-a35ecd0bbb93",
                "updated-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "updated-at" "2022-03-15T09:09:45Z",
                "bulk-scheduled" true,
                "name" "ReportingTransforms",
                "created-at" "2021-11-15T13:29:30Z",
                "created-by" "e538ac0d-2b7f-44b1-843c-106e450cb41e",
                "client-id" "2e9ba4ca-45d9-45f4-b5bc-1c9164ba1719",
                "description" nil
            }
        ],
        "pagination" {
            "items-per-page" 999999,
            "page" 0,
            "total-pages" 1
        }
    }
}
)
